import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { CommonAction } from '@stores/common/action';
import type { LotteryAction } from '@stores/lottery/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav from '@components/tabNav';
import NineGridLottery from './components/nineGridLottery';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import CommonRulePopup from "@components/commonRulePopup";
import CommonSharePopup from "@components/commonSharePopup";
import CommonPopupNew from "@components/commonPopupNew";
import { px2rem } from '@utils/px2rem';
// import { setThemeColor, toRgba, hexToRgb, getThemeColor } from '@utils/colorConversion';
import Avatar from '@components/avatar';
import CountDown from "@components/countDown";
import { formatDateTime } from '@utils/timeUtils';
import Toast from '@components/Toast';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Image, Spin } from 'antd';
import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';
import updateImageListSrc from "@utils/update-image-list-src";

interface LotteryH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    common?: CommonAction;
    lottery?: LotteryAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    lotteryDetail?: any
    navList?: any
    navCurrentIndex?: any
    navCurrentType?: any
    navClick?: Function
    themeColor?: any
    updateLotteryDetail?: (newDetail: any) => void
    // ruleValue?: any
}
interface LotteryH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    scrollY: any
    rulePopupStatus: boolean
    sharePopupStatus: boolean
    downloadAppStatus: boolean;
    headerShowStatus: boolean;
    showFixedNav: boolean; // 是否显示悬浮导航
    // lotteryDetail: any
    // prizeList: any
    currentCount: any
    claimedRewards: any
    extraClaimedCount: any
    showExtraModal: boolean
    // inviteUserList: any
    // themeColor: any
    lotteryResultPopupStatus: boolean   // 抽奖结果弹框
    currentLotteryPrizeResultData: any    // 抽到的奖品结果
    inviteLotteryPrizeResultData: any    // 邀请得到的奖品结果
    openPrizeType: any  // 奖品结果的类型（1是邀请后得到的奖品结果，2是抽奖得到的奖品结果）
    myLotteryCouponPopupStatus: boolean  // 我的抽奖券弹框
    lotteryActivitiesTickets: any   // 抽奖券记录
    ticketsPage: number  // 抽奖券记录当前页
    ticketsHasMore: boolean  // 抽奖券记录是否还有更多
    ticketsLoading: boolean  // 抽奖券记录加载中状态
    myLotteryRecordPopupStatus: boolean  // 我的中奖记录弹框
    lotteryActivitiesRecords: any   // 我的中奖记录
    recordsPage: number  // 中奖记录当前页
    recordsHasMore: boolean  // 中奖记录是否还有更多
    recordsLoading: boolean  // 中奖记录加载中状态
    myInviteUserListPopupStatus: boolean,  // 我的邀请好友弹框
    lotteryActivitiesInvitations: any   // 邀请好友记录列表 
    invitationsPage: number  // 邀请记录页码
    invitationsHasMore: boolean  // 邀请记录是否还有更多
    invitationsLoading: boolean  // 邀请记录加载中状态
    myInviteUserTabList: any,  // 我的邀请好友tab切换
    currentInviteTabIype: any,    // 当前选中的邀请好友的tab
    inviteCode: any // 邀请码
    lotteryActivitiesSurprises: any // 额外惊喜列表
    surprisesPage: number  // 额外惊喜页码
    surprisesHasMore: boolean  // 额外惊喜是否还有更多
    surprisesLoading: boolean  // 额外惊喜加载中状态
    showMyRankInfo: boolean  // 是否显示我的排名信息
    prizeQueueInitialized: boolean  // 奖品队列是否已初始化
    lotteryActivitiesBarrage: any   // 中奖弹幕列表
    pendingPrizeQueue: any[]  // 待领取奖品队列
    ruleText: any   // 规则内容
    ruleType: any   // 规则类型
    inviteForUserPopupStatus: boolean   // 被邀请后的弹框提示
    weiXinTipMask: boolean  // 微信内弹框提示浏览器打开
}
@inject('app', 'site', 'user', 'lottery')
@observer
class LotteryH5Page extends BasePage<LotteryH5PageProps, LotteryH5State> {
    scrollCleanup = null;
    private navBoxRef: HTMLDivElement | null = null;
    private fixedNavRef: React.RefObject<HTMLDivElement> = React.createRef();
    private rankSectionRef: HTMLDivElement | null = null;
    private myRankInfoRef: HTMLDivElement | null = null;
    private rankSectionObserver: IntersectionObserver | null = null;
    private rankSectionInView: boolean = false;  // 拉新冲榜模块是否在可视区域内
    private scrollStopTimer: NodeJS.Timeout | null = null;
    
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        scrollY: 0,
        rulePopupStatus: false,
        sharePopupStatus: false,
        downloadAppStatus: true,
        headerShowStatus: false,
        showFixedNav: false, // 悬浮导航是否显示
        currentCount: 10,   // 当前累计人数
        claimedRewards: new Set(), // 已发放的奖励里程碑索引
        extraClaimedCount: 1,    // 额外惊喜已发放次数
        showExtraModal: false,  // 额外奖励弹框
        // themeColor: '', // 主题色
        lotteryResultPopupStatus: false, // 抽奖结果弹框
        currentLotteryPrizeResultData: {},  // 抽到的奖品结果
        inviteLotteryPrizeResultData: {},   // 邀请得到的奖品结果
        openPrizeType: 2,  // 奖品结果的类型（1是邀请后得到的奖品结果，2是抽奖得到的奖品结果）
        myLotteryCouponPopupStatus: false,  // 我的抽奖券弹框
        lotteryActivitiesTickets: [],   // 抽奖券记录
        ticketsPage: 1,  // 抽奖券记录当前页
        ticketsHasMore: true,  // 抽奖券记录是否还有更多
        ticketsLoading: false,  // 抽奖券记录加载中状态
        myLotteryRecordPopupStatus: false,  // 我的中奖记录弹框
        lotteryActivitiesRecords: [],   // 我的中奖记录
        recordsPage: 1,  // 中奖记录当前页
        recordsHasMore: true,  // 中奖记录是否还有更多
        recordsLoading: false,  // 中奖记录加载中状态
        myInviteUserListPopupStatus: false,  // 我的邀请好友弹框
        lotteryActivitiesInvitations: [],  // 邀请好友记录列表
        invitationsPage: 1,  // 邀请记录页码
        invitationsHasMore: true,  // 邀请记录是否还有更多
        invitationsLoading: false,  // 邀请记录加载中状态
        myInviteUserTabList: [
            {name: '我的邀请', type: 0},
            {name: '额外惊喜', type: 1}
        ],    // 我的邀请好友tab切换list
        currentInviteTabIype: 0,    // 当前选中的邀请好友的tab 
        inviteCode: '', // 邀请码
        lotteryActivitiesSurprises: [], // 额外惊喜列表
        surprisesPage: 1,  // 额外惊喜页码
        surprisesHasMore: true,  // 额外惊喜是否还有更多
        surprisesLoading: false,  // 额外惊喜加载中状态
        showMyRankInfo: false,  // 默认不显示我的排名信息
        prizeQueueInitialized: false,  // 奖品队列未初始化
        lotteryActivitiesBarrage: [],   // 中奖弹幕列表
        pendingPrizeQueue: [],  // 待领取奖品队列
        ruleText: '',   // 规则内容
        ruleType: 0,   // 规则类型0是抽奖规则，1是拉新规则
        inviteForUserPopupStatus: false,    // 被邀请后的弹框提示
        weiXinTipMask: false,   // 微信内弹框提示浏览器打开
    };
    
    async componentDidMount() {
        const { app, user, lottery, site, location, lotteryDetail } = this.props;
        const params = new URLSearchParams(location.search);
        const isPreviewFrame = params.get('previewFrame') === '1';
        
        if (site) {
            this.setState({
                downloadAppStatus: site.getAppDownloadShowStatus(),
                headerShowStatus: site.getShowHeader(),
            }, () => {
                site.setShowHeader(false);
                site.setAppDownloadShowStatus(true);
            })
        }

        document.title = '抽奖';

        // 直接在组件内添加滚动监听
        const handleScroll = () => {
            const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
            this.handleScroll(scrollY);
        };
        
        window.addEventListener('scroll', handleScroll);
        
        // 保存清理函数
        this.scrollCleanup = () => {
            window.removeEventListener('scroll', handleScroll);
        };
        
        // 立即获取一次当前滚动位置
        const initialScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        this.handleScroll(initialScrollY);
        
        super.componentDidMount();
    }

    componentDidUpdate(prevProps: LotteryH5PageProps) {
        const { lotteryDetail } = this.props;
        const { prizeQueueInitialized, pendingPrizeQueue, lotteryResultPopupStatus } = this.state;
        
        // 当 lotteryDetail.id 从无到有的时候，获取弹幕数据和调用分享
        if (lotteryDetail?.id && !prevProps.lotteryDetail?.id) {
            this.fetchLotteryActivitiesBarrageData();
            this.submitLotteryActivitiesOpenShare();
            if(lotteryDetail.user?.inviter) {
                this.setState({
                    inviteForUserPopupStatus: true
                })
            }
            // 数据加载完成后，重新设置 Intersection Observer（此时 DOM 才真正渲染）
            this.setupRankSectionObserver();
        }
        
        // 初始化未领取奖品队列（只执行一次）
        if (lotteryDetail?.inviteTasks?.length > 0 && !prizeQueueInitialized && !lotteryResultPopupStatus) {
            // 筛选出 prizeReadAt 为 null 且 isFinished 为 true 的数据（未领取的奖品）
            const emptyPrizeReadAtList = lotteryDetail.inviteTasks?.filter(item => item.prizeReadAt == null && item.isFinished == true && item.userWinning);
            
            if (emptyPrizeReadAtList?.length > 0) {
                // 将未领取奖品加入队列并标记为已初始化
                this.setState({
                    pendingPrizeQueue: [...emptyPrizeReadAtList],
                    prizeQueueInitialized: true
                }, () => {
                    // 显示第一个奖品
                    this.showNextPrizeFromQueue();
                });
            } else {
                // 没有未领取奖品，也标记为已初始化
                this.setState({ prizeQueueInitialized: true });
            }
        }
    }

    componentWillUnmount() {
        let { headerShowStatus } = this.state;
        const { site } = this.props;
        if(site) {
            site.setShowHeader(headerShowStatus);
        }
        
        // 清理滚动监听
        if (this.scrollCleanup) {
            this.scrollCleanup();
        }
        
        // 清理 Intersection Observer
        if (this.rankSectionObserver) {
            this.rankSectionObserver.disconnect();
        }

        // 清理滚动停止定时器
        if (this.scrollStopTimer) {
            clearTimeout(this.scrollStopTimer);
        }
        
        document.title = '';
    }

    // 获取当前下载入口显示状态（实时从 store 获取）
    getDownloadAppStatus = (): boolean => {
        const { site } = this.props;
        return site?.appDownloadShowStatus ?? false;
    }
    // 获取页面顶部 paddingTop
        getWrapperPaddingTop = (): string | number => {
        const downloadAppStatus = this.getDownloadAppStatus();
        return downloadAppStatus ? px2rem(88) : 0;
    }
    
    handleScroll = (scrollY: number) => {
        const navBoxOffsetTop = this.navBoxRef?.offsetTop || 750;
        const shouldShowFixed = scrollY > navBoxOffsetTop;
        
        // 只在状态改变时更新
        if (this.state.showFixedNav !== shouldShowFixed) {
            this.setState({ 
                scrollY: scrollY,
                showFixedNav: shouldShowFixed 
            });
        }

        // 滚动时隐藏 myRankInfoBox（直接操作 DOM，避免 setState 导致的渲染竞争）
        const el = this.myRankInfoRef;
        if (el && el.style.opacity !== '0') {
            el.style.opacity = '0';
            el.style.pointerEvents = 'none';
        }
        // 停止滚动后，如果拉新冲榜模块在可视区域内则重新显示
        if (this.scrollStopTimer) {
            clearTimeout(this.scrollStopTimer);
        }
        this.scrollStopTimer = setTimeout(() => {
            if (this.rankSectionInView && el) {
                el.style.opacity = '1';
                el.style.pointerEvents = 'auto';
            }
        }, 200);
    }

    // 设置 Intersection Observer 监听拉新冲榜区域
    setupRankSectionObserver = () => {
        // 如果已经创建过 Observer，不重复创建
        if (this.rankSectionObserver) return;
        
        // 延迟执行，确保 DOM 已经渲染
        setTimeout(() => {
            const rankSection = this.rankSectionRef;
            if (!rankSection) return;
            
            // 创建 Intersection Observer（只跟踪可见状态，离开视口时隐藏 myRankInfoBox）
            this.rankSectionObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        this.rankSectionInView = entry.isIntersecting;
                        // 离开视口时直接隐藏
                        if (!entry.isIntersecting) {
                            const el = this.myRankInfoRef;
                            if (el) {
                                el.style.opacity = '0';
                                el.style.pointerEvents = 'none';
                            }
                        }
                    });
                },
                {
                    root: null, // 使用视口作为根
                    rootMargin: '0px',
                    threshold: 0.1 // 当 10% 的区域可见时触发
                }
            );
            
            // 开始监听
            this.rankSectionObserver.observe(rankSection);
            
            // 创建后立即检查一次当前可见状态
            const rect = rankSection.getBoundingClientRect();
            this.rankSectionInView = rect.top < window.innerHeight && rect.bottom > 0;
            if (this.rankSectionInView) {
                const el = this.myRankInfoRef;
                if (el) {
                    el.style.opacity = '1';
                    el.style.pointerEvents = 'auto';
                }
            }
        }, 500);
    }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 获取抽奖券记录
    fetchLotteryActivitiesTickets = async (page = 1, isLoadMore = false) => {
        const { lottery, lotteryDetail } = this.props;
        const { lotteryActivitiesTickets, ticketsLoading } = this.state;
        
        if (ticketsLoading) return; // 防止重复加载
        
        if (lottery && lotteryDetail?.id) {
            this.setState({ ticketsLoading: true });
            
            let params: any = {
                'page[number]': page,
                'page[size]': 20
            };
            
            try {
                const data: any = await lottery.getLotteryActivitiesTicketsData(lotteryDetail.id, params);
                
                if (data.code == 0) {
                    const newData = data.data?.data || [];
                    const pageInfo = data.data?.page || {};
                    
                    this.setState({
                        lotteryActivitiesTickets: isLoadMore 
                            ? [...lotteryActivitiesTickets, ...newData] 
                            : newData,
                        ticketsPage: page,
                        ticketsHasMore: pageInfo.hasMore !== false,
                        ticketsLoading: false
                    });
                } else {
                    this.setState({ ticketsLoading: false });
                }
            } catch (error) {
                console.error('获取抽奖券记录失败:', error);
                this.setState({ ticketsLoading: false });
            }
        }
    }

    // 加载更多抽奖券记录
    loadMoreTickets = () => {
        const { ticketsPage, ticketsHasMore, ticketsLoading } = this.state;
        
        if (!ticketsHasMore || ticketsLoading) return;
        
        this.fetchLotteryActivitiesTickets(ticketsPage + 1, true);
    }

    // 处理抽奖券列表滚动
    handleTicketsScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        
        // 当滚动到底部附近时触发加载更多
        if (scrollHeight - scrollTop - clientHeight < 50) {
            this.loadMoreTickets();
        }
    }

    // 获取邀请记录
    fetchLotteryActivitiesInvitations = async (page = 1, isLoadMore = false) => {
        const { lottery, lotteryDetail } = this.props;
        const { lotteryActivitiesInvitations, invitationsLoading } = this.state;
        
        if (invitationsLoading) return; // 防止重复加载
        
        if(lottery && lotteryDetail?.id) {
            this.setState({ invitationsLoading: true });
            
            let params:any = {
               'page[number]': page,
               'page[size]': 20
            }
            
            try {
                const data: any = await lottery.getLotteryActivitiesInvitationsData(lotteryDetail.id, params)
                console.log(data, '接口返回的邀请好友列表');
                
                if(data.code == 0) {
                    const newData = data.data?.data || [];
                    const pageInfo = data.data?.page || {};
                    
                    this.setState({
                        lotteryActivitiesInvitations: isLoadMore 
                            ? [...lotteryActivitiesInvitations, ...newData] 
                            : newData,
                        invitationsPage: page,
                        invitationsHasMore: pageInfo.hasMore !== false,
                        invitationsLoading: false
                    })
                } else {
                    this.setState({ invitationsLoading: false });
                }
            } catch (error) {
                console.error('获取邀请记录失败:', error);
                this.setState({ invitationsLoading: false });
            }
        }
    }

    // 加载更多邀请记录
    loadMoreInvitations = () => {
        const { invitationsPage, invitationsHasMore, invitationsLoading } = this.state;
        
        if (!invitationsHasMore || invitationsLoading) return;
        
        this.fetchLotteryActivitiesInvitations(invitationsPage + 1, true);
    }

    // 处理邀请列表滚动
    handleInvitationsScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        
        // 当滚动到底部附近时触发加载更多
        if (scrollHeight - scrollTop - clientHeight < 50) {
            this.loadMoreInvitations();
        }
    }

    // 获取本次中奖记录
    fetchLotteryActivitiesRecords = async (page = 1, isLoadMore = false) => {
        const { lottery, lotteryDetail } = this.props;
        const { lotteryActivitiesRecords, recordsLoading } = this.state;
        
        if (recordsLoading) return; // 防止重复加载
        
        if (lottery && lotteryDetail?.id) {
            this.setState({ recordsLoading: true });
            
            let params: any = {
                'page[number]': page,
                'page[size]': 20
            };
            
            try {
                const data: any = await lottery.getLotteryActivitiesRecordsData(lotteryDetail.id, params);
                console.log(data, '接口返回的中奖记录');
                
                if (data.code == 0) {
                    const newData = data.data?.data || [];
                    const pageInfo = data.data?.page || {};
                    
                    this.setState({
                        lotteryActivitiesRecords: isLoadMore 
                            ? [...lotteryActivitiesRecords, ...newData] 
                            : newData,
                        recordsPage: page,
                        recordsHasMore: pageInfo.hasMore !== false,
                        recordsLoading: false
                    });
                } else {
                    this.setState({ recordsLoading: false });
                }
            } catch (error) {
                console.error('获取中奖记录失败:', error);
                this.setState({ recordsLoading: false });
            }
        }
    }

    // 加载更多中奖记录
    loadMoreRecords = () => {
        const { recordsPage, recordsHasMore, recordsLoading } = this.state;
        
        if (!recordsHasMore || recordsLoading) return;
        
        this.fetchLotteryActivitiesRecords(recordsPage + 1, true);
    }

    // 处理中奖记录列表滚动
    handleRecordsScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        
        // 当滚动到底部附近时触发加载更多
        if (scrollHeight - scrollTop - clientHeight < 50) {
            this.loadMoreRecords();
        }
    }

    // 获取额外惊喜列表
    fetchLotteryActivitiesSurprises = async (page = 1, isLoadMore = false) => {
        const { lottery, lotteryDetail } = this.props;
        const { lotteryActivitiesSurprises, surprisesLoading } = this.state;
        
        if (surprisesLoading) return; // 防止重复加载
        
        if(lottery && lotteryDetail?.id) {
            this.setState({ surprisesLoading: true });
            
            let params:any = {
               'page[number]': page,
               'page[size]': 20
            }
            
            try {
                const data: any = await lottery.getLotteryActivitiesSurprisesData(lotteryDetail.id, params)
                console.log(data, '接口返回的额外惊喜列表');
                
                if(data.code == 0) {
                    const newData = data.data?.data || [];
                    const pageInfo = data.data?.page || {};
                    
                    this.setState({
                        lotteryActivitiesSurprises: isLoadMore 
                            ? [...lotteryActivitiesSurprises, ...newData] 
                            : newData,
                        surprisesPage: page,
                        surprisesHasMore: pageInfo.hasMore !== false,
                        surprisesLoading: false
                    })
                } else {
                    this.setState({ surprisesLoading: false });
                }
            } catch (error) {
                console.error('获取额外惊喜列表失败:', error);
                this.setState({ surprisesLoading: false });
            }
        }
    }

    // 加载更多额外惊喜
    loadMoreSurprises = () => {
        const { surprisesPage, surprisesHasMore, surprisesLoading } = this.state;
        
        if (!surprisesHasMore || surprisesLoading) return;
        
        this.fetchLotteryActivitiesSurprises(surprisesPage + 1, true);
    }

    // 处理额外惊喜列表滚动
    handleSurprisesScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        
        // 当滚动到底部附近时触发加载更多
        if (scrollHeight - scrollTop - clientHeight < 50) {
            this.loadMoreSurprises();
        }
    }

    // 获取中奖弹幕
    fetchLotteryActivitiesBarrageData = async () => {
        const { lottery, lotteryDetail } = this.props;
        if(lottery && lotteryDetail?.id) {
            const data: any = await lottery.getLotteryActivitiesBarrageData(lotteryDetail.id);
            console.log(data, '中奖弹幕列表');
            if(data.code == 0) {
                this.setState({
                    lotteryActivitiesBarrage: data.data?.data
                })
            }
        }
    }
    
    // 打开分享
    submitLotteryActivitiesOpenShare = async () => {
        const { lottery, lotteryDetail } = this.props;
        const routerParams = new URLSearchParams(this.props.location.search);
        const usercode: any = routerParams?.get('usercode') || '';
        console.log(lotteryDetail?.id, usercode, '分享')
        if(lottery && lotteryDetail?.id && usercode) {
            let params = {
                id: lotteryDetail?.id,
                code: usercode
            }
            const data: any = await lottery.submitLotteryActivitiesOpenShareData(params);
            // console.log(data, '分享接口结果')
        }
    }
    // 关闭弹框
    onHidePopup = () => {
        this.setState({
            rulePopupStatus: false,
            sharePopupStatus: false,
            myLotteryCouponPopupStatus: false,
            myLotteryRecordPopupStatus: false,
        })
    }


     // 抽奖方法
    handleDraw = async () => {
        const { lottery, lotteryDetail, updateLotteryDetail } = this.props;
        if (!this.props.user?.userInfo?.code) {
            const { user } = this.props as any;
            if (user && typeof user.checkLogin === 'function') {
                const isLogin = user.checkLogin();
                if (!isLogin) {
                    return;
                }
            }
            Toast.info({ content: '请先登录!' });
            return;
        }
        if(lottery && lotteryDetail?.id) {
            let params:any = {
               id: lotteryDetail.id
            }
            const data: any = await lottery.submitLotteryDrawData(params)
            console.log('父组件抽奖API返回:', data);
            if(data.code == 0) {
                // 重新获取抽奖详情数据（更新抽奖券数量和中奖记录）
                const res = await lottery.getLotteryActivitiesData(lotteryDetail.code);
                
                if(res.code == 0 && updateLotteryDetail) {
                    updateLotteryDetail(res.data);
                }
                
                // 兼容多种数据结构：data.data.xxx 或 data.xxx
                const prizeData = data.data;
                const returnData = {
                    prizeId: prizeData.prizeId || prizeData.id,
                    prizeName: prizeData.name || prizeData.prizeName,
                    prizeCover: prizeData.icon || prizeData.prizeCover,
                    isWin: prizeData.isWin !== undefined ? prizeData.isWin : true,
                };
                console.log('父组件返回给子组件的数据:', returnData);
                
                this.setState({
                    currentLotteryPrizeResultData: data.data,
                    
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            openPrizeType: 2,
                            lotteryResultPopupStatus: true
                        })
                    }, 4000)
                })
                return returnData;
            } else {
                // 只要接口有返回且 code !== 0，统一按业务处理失败提示；
                // 真正的断网/弱网/超时由抽奖 API 封装抛出 network 异常
                const err: any = new Error(data.msg || data.message || '抽奖失败');
                err.errorType = 'service';
                throw err;
            }
        }
        const err: any = new Error('当前活动人气爆棚，请稍后再试~');
        err.errorType = 'service';
        throw err;
    };

    // 打开抽奖规则
    handleOpenRule = () => {
        const { history } = this.props;
        console.log('打开抽奖规则');
        // history?.push('/lottery-rule');
    }

    // 查看中奖记录
    handleViewRecord = () => {
        const { history } = this.props;
        console.log('查看中奖记录');
        // history?.push('/lottery-record');
    }

    // 检查并自动发放里程碑奖励
    checkMilestones = (newCount) => {
        const { claimedRewards, extraClaimedCount } = this.state;
        const MILESTONES = [
            { target: 2, isExtra: false },
            { target: 3, isExtra: false },
            { target: 5, isExtra: false },
            { target: 7, isExtra: false },
            { target: 20, isExtra: true, limit: 10 },
        ];
        
        MILESTONES.forEach((milestone, index) => {
            if (newCount >= milestone.target && !claimedRewards.has(index)) {
                if (milestone.isExtra) {
                    if (extraClaimedCount < milestone.limit) {
                        this.grantExtraReward(index);
                    }
                } else {
                    this.grantReward(index);
                }
            }
        });
    };

    // 发放普通奖励
    grantReward = (index) => {
        this.setState(prev => ({
            claimedRewards: new Set(prev.claimedRewards).add(index)
        }));
        console.log(`奖励${index}已到账`);
        // 可以加 toast 提示
    };

    // 发放额外惊喜奖励
    grantExtraReward = (index) => {
        this.setState(prev => ({
            claimedRewards: new Set(prev.claimedRewards).add(index),
            extraClaimedCount: prev.extraClaimedCount + 1
        }));
        console.log(`额外惊喜已到账，已发放${this.state.extraClaimedCount + 1}/10份`);
    };
    // 判断是否是微信
    isWeixin() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
    }

    // 微信覆盖提示
    isWeixinXml() {
        return (
            <div className={styles.opAlertTable} onClick={() => {
                this.setState({ weiXinTipMask: false } as any);
            }}>
                <div className={styles.alertWhite}>
                    <div className={styles.inter}></div>
                    点击右上角选择在默认浏览器中打开
                </div>
            </div>
        );
    }

    // 去赚抽奖券
    goMakeCoupon = () => {
        let { lotteryDetail } = this.props;
        this.setState({
            myLotteryCouponPopupStatus: false
        }, () => {
            if(lotteryDetail.user?.remainingTickets == 0) { // 此时可用抽奖券为0，点击去赚抽奖券，页面滚动至任务的模块
                window.scrollBy({ top: 850, behavior: 'smooth' });
            }
        })
        
    }

    // 邀请好友、额外惊喜切换事件
    inviteTabClick = (tab) => {
        this.setState({
            currentInviteTabIype: tab.type
        })
    }

    // 点击奖品里的去领取、去查看、已到账按钮、已领取，跳转到app的我的奖品页面
    prizeClick = (data) => {
        window.location.href = `vivoclub://com.vivo.club/deep?page=page_my_prize`;
        // 3秒后如果应用没有打开，跳转到应用商城
        setTimeout(() => {
            window.open(`https://m.malink.cn/s/ABbE73`)
        }, 3000);
        // if(data.prizeType == 0) {   // 是抽奖券
        // } else if(data.prizeType == 1) {    // 是奖品
        //     if(data.userWinning?.prizeType == 2) {  // 是奖品-实物
        //         if(data.userWinning?.isReceived) {  // 未领取
        //         } else {    // 已领取
        //         }
        //     } else {    // 1是V币、3是优惠券、4是谢谢参与
        //     }
        // }

    }
    // 邀请好友，获取邀请码，复制链接
    inviteFriend = async () => {
        let { user, common, lotteryDetail } = this.props;
        if (!user?.userInfo?.code) {
            // const { user } = this.props as any;
            if (user && typeof user.checkLogin === 'function') {
                const isLogin = user.checkLogin();
                if (!isLogin) {
                    return;
                }
            }
            Toast.info({ content: '请先登录!' });
            return;
        }
        if(lotteryDetail.status > 1){
            Toast.info({ content: '抽奖活动已结束!' });
            return;
        }
        if(common && lotteryDetail?.id) {
            const params = {
                type: 2,
                id: lotteryDetail.id
            };
            const res = await common.getInviteLinkCreate(params);
            console.log(res, '邀请码');
            if(res.code == 0) {
                this.setState({
                    inviteCode: res.data?.code,
                    sharePopupStatus: true
                })
            }
        }
    }

    // 去完成任务
    handleTaskClick = (task) => {
        const { user, lotteryDetail } = this.props;
        // 任务提交前统一走登录检查，不以可能过期的 userInfo.code 代替会话判断。
        if (task.type != 5 && !user?.checkLogin('h5', window.location.href)) return;
        if(task.type == 0) {    // 发表帖子
            if(task.topic?.id) {
                this.props.history && this.props.history.push(`/setPost?topicId=${task.topic?.id}`);
            } else {
                this.props.history && this.props.history.push(`/setPost`);
            }
        } else if(task.type == 1) {     // 发表评论
            if(task.thread?.id) {
                this.props.history && this.props.history.push(`/threadDetail/${task.thread?.id}`);
            } else {
                this.props.history && this.props.history.push(`/`);
            }
        } else if(task.type == 2) { // 点赞帖子
            if(task.thread?.id) {
                this.props.history && this.props.history.push(`/threadDetail/${task.thread?.id}`);
            } else {
                this.props.history && this.props.history.push(`/`);
            }
        } else if(task.type == 3) { // 分享活动
            this.setState({
                inviteCode: '',
                sharePopupStatus: true
            })
        } else if(task.type == 4) { // 填写表单
            if(task.form?.threadId) {
                this.props.history && this.props.history.push(`/threadDetail/${task.form?.threadId}`);
            } else {
                this.props.history && this.props.history.push(`/`);
            }
        } else if(task.type == 5) { // 入驻App
            // window.location.href = `vivoclub://com.vivo.club/deep?page=page_lottery_detail&id=${lotteryDetail?.id}&action=H5openLotteryApp`;
            // // 3秒后如果应用没有打开，跳转到应用商城
            // setTimeout(() => {
            //     window.open(`https://m.malink.cn/s/ABbE73`)
            // }, 3000);
            this.openAppLotteryDetailPage();
        } else if(task.type == 6) {
            this.lotteryOpenUrl(task.id, task.url);
        }
    }

    // 完成打开链接任务
    lotteryOpenUrl = async(id, url) => {
        const { lottery, user } = this.props;
        if(lottery) {
            const res = await lottery.submitLotteryOpenUrlData({taskId: id})
            if (Number(res.code) === -3001 || Number(res.code) === 401) {
                // Cookie/内存状态可能仍存在，接口已确认失效时必须强制重新登录。
                user?.checkLogin('h5', window.location.href, true);
                return;
            }
            if(res.code == 0) {
                window.open(url)
            }
        }
    }

    // 打开app端抽奖详情页
    openAppLotteryDetailPage = () => {
        const { lotteryDetail } = this.props;
        if(this.isWeixin()) {
            this.setState({
                weiXinTipMask: true
            });
            return false;
        }
        window.location.href = `vivoclub://com.vivo.club/deep?page=page_lottery_detail&code=${lotteryDetail?.code}&action=H5openLotteryApp`;
        // 3秒后如果应用没有打开，跳转到应用商城
        setTimeout(() => {
            window.open(`https://m.malink.cn/s/ABbE73`)
        }, 3000);
    }

    // 任务列表
    taskList = () => {
        // 获取按钮状态文案
        const getButtonStatusText = (lotteryStatus, taskStatus, task) => {
        if (lotteryStatus === 3) return '已结束';
        if (lotteryStatus === 0) return '未开始';
        if (taskStatus) return '已完成';
        return task.buttonText;
        };

        // 判断按钮是否禁用：点赞、评论、发帖任务完成后仍允许再次进入目标页面
        const isBtnDisabled = (lotteryStatus, taskStatus, lotteryDisabled, canRepeatNavigate) => {
            return (taskStatus && !canRepeatNavigate) || lotteryDisabled;
        };
        const { lotteryDetail } = this.props;
        const lotteryStatus = lotteryDetail?.status;
        const lotteryDisabled = (lotteryStatus === 3 || lotteryStatus === 0); // 未开始或已结束时按钮灰色
        
        // 如果没有任务列表，返回空
        if (!lotteryDetail?.tasks?.length) return null;

        return (
            <div className={styles.taskList}>
            {lotteryDetail.tasks.map((task) => {
                // 点赞、评论、发帖完成后保留跳转能力，方便用户再次进入对应内容
                const canRepeatNavigate = [0, 1, 2].includes(Number(task.type));
                const disabled = isBtnDisabled(
                    lotteryStatus,
                    task.finishedTimes == task.upperLimit,
                    lotteryDisabled,
                    canRepeatNavigate
                );
                const btnText = getButtonStatusText(lotteryStatus, task.status, task);
                
                return (
                <div className={styles.productTaskItem} key={task.rule}>
                    <div className={styles.iconBox}>
                        {/* <img src={task.icon} alt="" className={styles.icon} /> */}
                        {task.type == 0 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Icon">
                                <g id="Group 427322144">
                                    <path id="Vector 841" d="M20.3203 2L30.0403 11.72" stroke={lotteryDetail.foregroundColor} strokeWidth="3" strokeLinecap="round"/>
                                    <path id="Vector 840" d="M12.7609 18.8949L7.79294 23.8629M27.137 16.5924L19.6633 27.4171C19.5328 27.606 19.3238 27.7257 19.0948 27.7425L3.8522 28.8614C2.88275 28.9326 2.0976 28.0861 2.24132 27.1247L4.49587 12.0436C4.53173 11.8037 4.68013 11.5955 4.89514 11.4834L15.9138 5.73635C16.4838 5.43904 17.1793 5.53345 17.6495 5.97195L26.9234 14.6217C27.4734 15.1347 27.5643 15.9734 27.137 16.5924Z" stroke={lotteryDetail.foregroundColor} strokeWidth="3" strokeLinecap="round"/>
                                </g>
                            </g>
                        </svg>}
                        {task.type == 1 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="icon">
                        <path id="Union" d="M15.9925 2.00052C17.8512 1.99675 19.6925 2.36696 21.4055 3.08841C23.0775 3.78926 24.5963 4.81133 25.8743 6.0972C27.1561 7.38092 28.1762 8.9025 28.8772 10.5757C29.602 12.313 29.9704 14.1601 29.9641 16.063C29.9547 17.9566 29.5803 19.7913 28.846 21.5161L28.7093 21.8267C28.0088 23.3677 27.0431 24.7555 25.8362 25.9536C24.5596 27.2255 23.0468 28.2358 21.3831 28.9283C19.677 29.6375 17.8678 30.0005 15.9993 30.0005H15.9329C13.7669 29.9898 11.6323 29.4762 9.69852 28.5005H4.95535L4.80887 28.4927C4.08684 28.4191 3.52102 27.8069 3.52078 27.063V22.313C2.55212 20.3882 2.03316 18.2345 2.02371 16.0659C2.01198 14.1912 2.37603 12.3323 3.09305 10.6001C3.78387 8.93444 4.7924 7.41898 6.0618 6.13821C7.24883 4.93514 8.64499 3.95994 10.1809 3.25931L10.4895 3.12259C12.2113 2.38512 14.0394 2.00993 15.93 2.00052H15.9925ZM15.387 5.01712C14.0922 5.0865 12.8495 5.37573 11.6712 5.8804L11.6682 5.88138C10.3688 6.43636 9.189 7.2388 8.19656 8.24466L8.19266 8.24954C7.19767 9.25344 6.40531 10.4411 5.86356 11.7466L5.86453 11.7476C5.37107 12.9397 5.09071 14.2085 5.03445 15.4947L5.02371 16.0474V16.0533C5.03116 17.7569 5.44001 19.4532 6.20047 20.9644L6.52078 21.6011V25.5005H10.4134L11.0501 25.8218C12.5693 26.5883 14.2469 26.9922 15.9485 27.0005H15.9993C17.4731 27.0005 18.8906 26.7157 20.2307 26.1587L20.7141 25.9439C21.8275 25.4154 22.8441 24.7003 23.719 23.8286L23.7229 23.8247C24.7351 22.8199 25.5278 21.6498 26.0852 20.3413L26.2884 19.8296C26.7306 18.628 26.9585 17.3616 26.9651 16.0484C26.9694 14.5471 26.6789 13.0977 26.1087 11.731V11.73C25.5581 10.4176 24.7569 9.22448 23.7513 8.21731L23.7464 8.21243C22.7452 7.2051 21.5552 6.40402 20.2454 5.85501L20.2405 5.85306C18.8981 5.28775 17.4558 4.99763 15.9993 5.00052H15.9456L15.387 5.01712ZM10.3802 14.2222C11.205 14.2224 11.8762 14.8942 11.8763 15.7222C11.8763 16.5502 11.2081 17.222 10.3802 17.2222C9.55516 17.2222 8.88309 16.5503 8.88309 15.7222C8.8831 14.8941 9.55517 14.2222 10.3802 14.2222ZM16.6175 14.2222C17.4424 14.2223 18.1145 14.8941 18.1145 15.7222C18.1145 16.5503 17.4424 17.2221 16.6175 17.2222C15.7925 17.2222 15.1204 16.5503 15.1204 15.7222C15.1204 14.8941 15.7925 14.2222 16.6175 14.2222ZM22.8548 14.2222C23.6798 14.2222 24.3518 14.8941 24.3518 15.7222C24.3518 16.5503 23.6798 17.2222 22.8548 17.2222C22.0298 17.2222 21.3577 16.5503 21.3577 15.7222C21.3577 14.8941 22.0298 14.2222 22.8548 14.2222Z" fill={lotteryDetail.foregroundColor}/>
                            </g>
                        </svg>}
                        {task.type == 2 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="hot">
                                <g id="Group 427322145">
                                    <path id="Rectangle 34624760" d="M3 14.7778C3 13.1209 4.34315 11.7778 6 11.7778H7.73658C9.20036 11.7778 10.5472 10.9782 11.2482 9.69319L14.5984 3.55117C15.1199 2.59495 16.1221 2 17.2114 2C19.0684 2 20.472 3.68183 20.1398 5.50889L19.2143 10.5989C19.1027 11.2127 19.5743 11.7778 20.1982 11.7778H24.0966C26.5546 11.7778 28.431 13.9738 28.0477 16.4016L26.6442 25.2905C26.3372 27.2347 24.6614 28.6667 22.6931 28.6667H6C4.34315 28.6667 3 27.3235 3 25.6667V14.7778Z"  stroke={lotteryDetail.foregroundColor} strokeWidth="3"/>
                                    <line id="Line 51" x1="10.5" y1="18.5" x2="10.5" y2="22.5"  stroke={lotteryDetail.foregroundColor} strokeWidth="3" strokeLinecap="round"/>
                                </g>
                            </g>
                        </svg>}
                        {task.type == 3 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Icon">
                                <path id="Union" fillRule="evenodd" clipRule="evenodd" d="M12.2383 1.63329C13.035 1.40762 13.8647 1.87084 14.0908 2.66746C14.3167 3.46431 13.8534 4.29386 13.0566 4.52C8.16216 5.90811 4.57841 10.4125 4.57812 15.7505C4.57812 22.1972 9.80292 27.4223 16.2471 27.4223C21.5905 27.4222 26.0993 23.8281 27.4805 18.9214C27.7053 18.1244 28.5339 17.6599 29.3311 17.8843C30.1281 18.1089 30.5923 18.9377 30.3682 19.7348C28.6325 25.9005 22.9697 30.4222 16.2471 30.4223C8.14535 30.4223 1.57812 23.8533 1.57812 15.7505C1.57841 9.03611 6.08676 3.37783 12.2383 1.63329ZM28.4463 2.05711C29.2747 2.05716 29.9463 2.72872 29.9463 3.55711V11.2153C29.946 12.0435 29.2745 12.7153 28.4463 12.7153C27.6181 12.7152 26.9466 12.0434 26.9463 11.2153V6.75926C23.0483 8.62506 19.8139 11.6749 17.7236 15.4985L17.3174 16.2417C16.92 16.9683 16.008 17.2365 15.2812 16.8393C14.5545 16.4421 14.2876 15.53 14.6846 14.8032L15.0908 14.06C17.1407 10.3101 20.1528 7.21172 23.7793 5.05711H20.7881C19.9599 5.05704 19.2883 4.38528 19.2881 3.55711C19.2881 2.72873 19.9597 2.05718 20.7881 2.05711H28.4463Z" fill={lotteryDetail.foregroundColor}/>
                            </g>
                        </svg>}
                        {task.type == 4 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Frame 427321653" clipPath="url(#clip0_5659_375341)">
                                <g id="Frame">
                                    <path id="Vector" d="M9 19L23 19"  stroke={lotteryDetail.foregroundColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path id="Vector_2" d="M9 14L16 14"  stroke={lotteryDetail.foregroundColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path id="Vector_3" d="M11.0967 6.5H20.9033C25.4969 6.5 27.7796 8.35302 28.9971 10.3232C30.2859 12.4091 30.5 14.8342 30.5 16C30.5 17.1669 30.2856 19.5913 28.9971 21.6768C27.7799 23.6466 25.4979 25.5 20.9033 25.5H11.0967C6.50208 25.5 4.22005 23.6466 3.00293 21.6768C1.71443 19.5913 1.5 17.1669 1.5 16C1.5 14.8331 1.71443 12.4087 3.00293 10.3232C4.22005 8.35341 6.50208 6.5 11.0967 6.5Z" stroke={lotteryDetail.foregroundColor} strokeWidth="3"/>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_5659_375341">
                                    <rect width="32" height="32" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>}
                        {task.type == 5 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="icon">
                                <g id="V">
                                    <mask id="path-1-outside-1_5659_375363" maskUnits="userSpaceOnUse" x="1.92188" y="2.83398" width="29" height="28" fill="black">
                                        <rect fill="white" x="1.92188" y="2.83398" width="29" height="28"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8.97562 5.83398C11.2146 5.83422 13.0786 7.64923 13.0674 9.9209C13.0616 11.1729 12.5797 12.2133 11.6455 13.0576L7.05569 16.9785C6.23804 17.6765 7.28686 18.9264 8.10452 18.2256L20.3067 7.80762C22.036 6.33132 24.648 6.54949 26.1123 8.29297C27.5734 10.0393 27.3571 12.6702 25.628 14.1465L11.751 25.998C11.0132 26.627 10.0409 26.9941 9.07523 27C6.68528 27.0113 4.92212 24.9865 4.9219 22.6143V9.95898C4.91336 7.70142 6.73645 5.84564 8.97562 5.83398Z"/>
                                    </mask>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.97562 5.83398L8.97594 2.83398L8.96797 2.83398L8.96 2.83402L8.97562 5.83398ZM13.0674 9.9209L10.0674 9.90616L10.0674 9.90701L13.0674 9.9209ZM11.6455 13.0576L13.5941 15.3386L13.626 15.3114L13.6571 15.2833L11.6455 13.0576ZM7.05569 16.9785L9.00345 19.2602L9.00427 19.2595L7.05569 16.9785ZM8.10452 18.2256L6.15657 15.944L6.15215 15.9478L8.10452 18.2256ZM20.3067 7.80762L18.3589 5.52595L18.3587 5.52606L20.3067 7.80762ZM26.1123 8.29297L28.4133 6.36794L28.4096 6.36353L26.1123 8.29297ZM25.628 14.1465L23.68 11.8649L23.6797 11.8652L25.628 14.1465ZM11.751 25.998L13.6973 28.2811L13.6993 28.2793L11.751 25.998ZM9.07523 27L9.08936 30L9.09341 29.9999L9.07523 27ZM4.9219 22.6143H1.92191V22.6145L4.9219 22.6143ZM4.9219 9.95898H7.92193L7.92188 9.94763L4.9219 9.95898ZM8.97562 5.83398L8.9753 8.83398C9.5919 8.83405 10.0702 9.33681 10.0674 9.90616L13.0674 9.9209L16.0674 9.93563C16.0869 5.96165 12.8373 2.8344 8.97594 2.83398L8.97562 5.83398ZM13.0674 9.9209L10.0674 9.90701C10.0657 10.2836 9.96658 10.5313 9.63396 10.832L11.6455 13.0576L13.6571 15.2833C15.1929 13.8952 16.0575 12.0623 16.0674 9.93479L13.0674 9.9209ZM11.6455 13.0576L9.69696 10.7766L5.10712 14.6975L7.05569 16.9785L9.00427 19.2595L13.5941 15.3386L11.6455 13.0576ZM7.05569 16.9785L5.10794 14.6968C4.2754 15.4075 3.78095 16.4156 3.76018 17.5095C3.74084 18.5283 4.13277 19.417 4.66982 20.0563C5.20642 20.695 6.02067 21.2419 7.04364 21.3925C8.14455 21.5547 9.22594 21.2156 10.0569 20.5034L8.10452 18.2256L6.15215 15.9478C6.57427 15.586 7.21794 15.3535 7.91778 15.4566C8.53968 15.5481 8.98951 15.8703 9.2639 16.1969C9.53875 16.5241 9.77068 17.0133 9.7591 17.6233C9.74609 18.3085 9.42716 18.8985 9.00345 19.2602L7.05569 16.9785ZM8.10452 18.2256L10.0525 20.5071L22.2546 10.0892L20.3067 7.80762L18.3587 5.52606L6.15657 15.944L8.10452 18.2256ZM20.3067 7.80762L22.2545 10.0893C22.7139 9.69705 23.4202 9.75225 23.8151 10.2224L26.1123 8.29297L28.4096 6.36353C25.8757 3.34672 21.3581 2.96558 18.3589 5.52595L20.3067 7.80762ZM26.1123 8.29297L23.8114 10.218C24.2216 10.7083 24.1523 11.4617 23.68 11.8649L25.628 14.1465L27.5759 16.4281C30.5618 13.8788 30.9252 9.3704 28.4133 6.36794L26.1123 8.29297ZM25.628 14.1465L23.6797 11.8652L9.80271 23.7168L11.751 25.998L13.6993 28.2793L27.5763 16.4277L25.628 14.1465ZM11.751 25.998L9.80476 23.715C9.59525 23.8936 9.30278 23.9986 9.05704 24.0001L9.07523 27L9.09341 29.9999C10.779 29.9897 12.4312 29.3603 13.6973 28.2811L11.751 25.998ZM9.07523 27L9.06109 24C8.75995 24.0015 8.5112 23.8875 8.30699 23.6663C8.08802 23.429 7.92195 23.0598 7.92191 22.614L4.9219 22.6143L1.92191 22.6145C1.92226 26.4033 4.80159 30.0202 9.08936 30L9.07523 27ZM4.9219 22.6143H7.92191V9.95898H4.9219H1.92191V22.6143H4.9219ZM4.9219 9.95898L7.92188 9.94763C7.91951 9.32103 8.43134 8.83686 8.99123 8.83394L8.97562 5.83398L8.96 2.83402C5.04156 2.85442 1.90721 6.08181 1.92193 9.97034L4.9219 9.95898Z" fill={lotteryDetail.foregroundColor} mask="url(#path-1-outside-1_5659_375363)"/>
                                </g>
                            </g>
                        </svg>}
                        {task.type == 6 && <svg width={px2rem(32)} height={px2rem(32)} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="&#233;&#147;&#190;&#230;&#142;&#165;">
                            <path id="Union" d="M18.6595 13.2095C19.2453 13.7953 19.2453 14.745 18.6595 15.3308C18.0737 15.9163 17.1239 15.9165 16.5382 15.3308C14.4284 13.2214 11.0078 13.2212 8.89814 15.3308L6.45779 17.7712C4.34843 19.8809 4.34841 23.3016 6.45779 25.4112C8.56744 27.5209 11.9881 27.5207 14.0979 25.4112L16.5382 22.9709C17.1239 22.3852 18.0737 22.3854 18.6595 22.9709C19.2453 23.5567 19.2453 24.5064 18.6595 25.0922L16.2192 27.5326C12.9378 30.8136 7.61769 30.8138 4.33647 27.5326C1.05552 24.2513 1.05554 18.9311 4.33647 15.6499L6.77681 13.2095C10.058 9.92828 15.3782 9.92846 18.6595 13.2095ZM26.957 4.91206C30.238 8.19329 30.2379 13.5135 26.957 16.7948L24.5166 19.2351C21.2354 22.5164 15.9153 22.5163 12.6339 19.2351C12.0481 18.6493 12.0481 17.6996 12.6339 17.1138C13.2197 16.5283 14.1696 16.5281 14.7552 17.1138C16.865 19.2234 20.2856 19.2235 22.3953 17.1138L24.8357 14.6734C26.945 12.5637 26.9451 9.14303 24.8357 7.03338C22.726 4.92374 19.3054 4.92395 17.1956 7.03338L14.7552 9.47372C14.1695 10.0595 13.2197 10.0593 12.6339 9.47372C12.0481 8.88794 12.0481 7.93819 12.6339 7.3524L15.0743 4.91206C18.3556 1.63106 23.6758 1.63085 26.957 4.91206Z" fill={lotteryDetail.foregroundColor}/>
                            </g>
                        </svg>}
                    </div>
                    <div className={styles.info}>
                    <div className={styles.taskName}>{task.name}（{task.finishedTimes}/{task.upperLimit}）</div>
                    <div className={styles.tip}>
                        {task.desc}
                        <img src={`${BASE_IMG_URL}/lottery/icon1.png`} alt="" className={styles.couponIcon} />
                        <span>+{task.rewardTickets}</span>
                    </div>
                    </div>
                    <div
                    className={classNames(styles.taskBtn, (disabled && task.type != 6) && styles.taskBtnOver)}
                    onClick={() => {
                        // 如果禁用状态，不执行任何操作
                        if (disabled && task.type != 6) return;
                        // 这里可以根据 task.rule 执行不同逻辑
                        this.handleTaskClick?.(task);
                    }}
                    >
                    {btnText}
                    </div>
                </div>
                );
            })}
            </div>
        );
    };

    // 邀请好友列表
    renderInviteUserList = () => {
        const { lotteryDetail } = this.props;
        let { lotteryActivitiesInvitations } = this.state;
        const TARGET_LENGTH = 10;
        const DEFAULT_ITEM = { avatar: '', code: '', nickname: '待加入', isPlaceholder: true };
        // console.log(lotteryActivitiesInvitations, '邀请列表');
        // 确保 lotteryActivitiesInvitations 是数组
        const lotteryActivitiesInvitationsArray = Array.isArray(lotteryDetail.inviteUsers) ? lotteryDetail.inviteUsers : [];
        
        // 处理数组：添加标识、补充、截取
        const processedList = (() => {
            // 给原始数据添加 isPlaceholder: false
            const realItems = lotteryActivitiesInvitationsArray?.map(item => ({ ...item, isPlaceholder: false }));
            const needCount = Math.max(0, TARGET_LENGTH - realItems.length);
            
            // 创建补充数据
            const placeholderItems = Array.from(
                { length: needCount }, 
                () => ({ ...DEFAULT_ITEM })
            );
            
            // 合并并截取
            return [...realItems, ...placeholderItems].slice(0, TARGET_LENGTH);
        })();
        console.log(processedList, '邀请列表');
        
        const hasMoreUsers = lotteryDetail.user?.inviteCount > TARGET_LENGTH;
        
        return (
            <div className={styles.inviteUserListOuter}>
                <div className={styles.inviteUserList}>
                    {processedList.map((user, index) => (
                        <div key={user.code || index} className={styles.inviteItemWrapper}>
                            {!user.isPlaceholder ? (
                                <div className={styles.inviteItem}>
                                    <Avatar
                                        avatarUrl={user.invitee?.avatar}
                                        userCode={user.invitee?.code}
                                        size={60}
                                    />
                                    <div className={styles.nickname}>{user.invitee?.nickname}</div>
                                    <div className={styles.prize}>抽奖券x{user.rewardTickets}</div>
                                </div>
                            ) : (
                                <div className={classNames(styles.inviteItem, styles.inviteItemGray)}>
                                    <img 
                                        src={`${BASE_IMG_URL}/lottery/avatar.png`} 
                                        alt="待加入" 
                                        className={styles.avatar}
                                    />
                                    <div className={styles.nickname}>待加入</div>
                                    <div className={styles.prize}>开抽奖券</div>
                                </div>
                            )}
                        </div>
                    ))}
                    
                    {hasMoreUsers && (
                        <div className={styles.allUser} onClick={async () => {
                            // 先加载数据，再显示弹框
                            await Promise.all([
                                this.fetchLotteryActivitiesInvitations(1, false),
                                this.fetchLotteryActivitiesSurprises(1, false)
                            ]);
                            this.setState({
                                myInviteUserListPopupStatus: true
                            })
                        }}>
                            全<br />部<br />{lotteryDetail.user?.inviteCount}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // 进度条渲染方法
    renderProgressBar = () => {
        const { currentCount, claimedRewards, extraClaimedCount } = this.state;
        const { lotteryDetail } = this.props;
        
        // 将接口返回的 inviteTasks 映射为 MILESTONES（固定长度5）
        const buildMILESTONES = () => {
            const tasks = lotteryDetail?.inviteTasks || [];
            
            // 按照 inviteCount 排序
            const sortedTasks = [...tasks].sort((a, b) => a.inviteCount - b.inviteCount);
            
            // 动态计算进度条宽度映射（基于排序后的索引和总节点数）
            const getProgressWidthByIndex = (index, total) => {
                // 将节点均匀分布在 10% 到 90% 之间
                // 第一个节点在 10%，最后一个节点在 90%
                if (total <= 1) return 50;
                const startPercent = 10;
                const endPercent = 90;
                const step = (endPercent - startPercent) / (total - 1);
                return startPercent + index * step;
            };
            
            return sortedTasks.map((task, index) => ({
                id: task.id,
                target: task.inviteCount,
                progressWidth: getProgressWidthByIndex(index, sortedTasks.length),
                rewardTickets: task.rewardTickets,
                prizeType: task.prizeType,
                prize: task.prize,
                isFinished: task.isFinished,
                type: task.type,
                isSoldOut: task.isSoldOut,
                userWinning: task.userWinning,
            }));
        };
        
        const MILESTONES = buildMILESTONES();
        
        // 计算当前进度宽度
        const getProgressWidth = () => {
            const inviteCount = lotteryDetail.user?.inviteCount || 0;
            
            if (MILESTONES.length === 0) return 0;
            
            const maxTarget = MILESTONES[MILESTONES.length - 1]?.target;
            if (!maxTarget) return 0;
            if (inviteCount === 0) return 0;
            if (inviteCount >= maxTarget) return 100;
            
            const nodeMap = [
                { target: 0, width: 0 },
                ...MILESTONES.map(m => ({ target: m.target, width: m.progressWidth })),
                { target: maxTarget, width: 100 }
            ];
            
            for (let i = 0; i < nodeMap.length - 1; i++) {
                const currentNode = nodeMap[i];
                const nextNode = nodeMap[i + 1];
                
                if (inviteCount >= currentNode.target && inviteCount < nextNode.target) {
                    const rangeCount = nextNode.target - currentNode.target;
                    const rangeWidth = nextNode.width - currentNode.width;
                    const progressInRange = inviteCount - currentNode.target;
                    
                    if (rangeCount === 0) return currentNode.width;
                    
                    const progress = currentNode.width + (progressInRange / rangeCount) * rangeWidth;
                    return Math.min(progress, 100);
                }
            }
            
            return 0;
        };
        
        const progressWidth = getProgressWidth();
        
        // 获取节点状态（完全对齐 Kotlin 逻辑）
        const getNodeStatus = (milestone) => {
            const inviteCount = lotteryDetail.user?.inviteCount || 0;
            const userWinning = milestone.userWinning;
            const order = userWinning?.order;
            
            // 任务未完成
            if (!milestone.isFinished) {
                return 'locked';
            }
            
            // 任务已完成，根据奖品类型判断
            // prizeType == 0: 抽奖券
            if (milestone.prizeType == 0) {
                if (milestone.prize?.isSoldOut == true) return 'soldOut';
                return 'granted';  // 已发放
            }
            
            // prizeType != 0，需要判断 prize.type
            const prizeType = milestone.prize?.type;
            
            // 实物奖品 type == 2
            if (prizeType == 2) {
                if (!userWinning) return 'soldOut';
                switch (userWinning.isReceived) {
                    case 0: return 'claimable';  // 去领取
                    case 1:
                        if (!order) return 'granted';
                        if (order.hasAddress == 0) return 'claimable';  // 去领取
                        if (order.isShipped) return 'shipped';  // 已发货
                        return 'pendingShipping';  // 待发货
                    default: return 'expired';  // 已过期
                }
            }
            
            // 虚拟奖品 type == 3
            if (prizeType == 3) {
                if (!userWinning) return 'soldOut';
                switch (userWinning.isReceived) {
                    case 0: return 'claimable';  // 去领取
                    case 1: return 'granted';  // 已发放
                    default: return 'expired';  // 已过期
                }
            }
            
            // 其他情况（没有 prize 或其他 prizeType）
            if (milestone.prize?.isSoldOut == true) return 'soldOut';
            return 'granted';
        };
        
        // 获取按钮显示文本
        const getButtonText = (milestone, status) => {
            switch (status) {
                case 'claimable': return '去领取';
                case 'granted': return '已发放';
                case 'soldOut': return '已抢完';
                case 'expired': return '已过期';
                case 'shipped': return '已发货';
                case 'pendingShipping': return '待发货';
                case 'locked':
                default:
                    // 任务未完成时的文案
                    if (milestone.prizeType >= 1 && milestone.prize) {
                        return milestone.prize?.isSoldOut ? '已抢完' : (milestone.prize?.award || '额外惊喜');
                    }
                    return '额外惊喜';
            }
        };
        
        // 判断图标是否可见（只有"已发放"时显示）
        const shouldShowIcon = (status) => {
            return status === 'granted';
        };
        
        // 判断节点是否激活（用于进度条圆点样式）
        const isNodeActive = (target) => {
            const inviteCount = lotteryDetail.user?.inviteCount || 0;
            return inviteCount >= target;
        };
        
        // 获取显示文本（奖品名称）
        const getDisplayText = (milestone) => {
            if (milestone.prizeType == 0) {
                return `抽奖券×${milestone.rewardTickets}`;
            }
            return milestone.prize?.name || '额外惊喜';
        };
        
        // 点击里程碑卡片（保留原有的打开 App 逻辑）
        const handleMilestoneClick = async(milestone) => {
            const status = getNodeStatus(milestone);
            
            // 已抢完或已过期，不可点击
            if (status === 'soldOut' || status === 'expired') {
                if (lotteryDetail.status > 1) {
                    Toast?.info?.({ content: '抽奖活动已结束' });
                    return;
                }
                if (status === 'soldOut') {
                    Toast?.info?.({ content: '奖品已抢完' });
                    return;
                }
                if (status === 'expired') {
                    Toast?.info?.({ content: '奖品已过期' });
                    return;
                }
                return;
            }
            
            // 未达到解锁条件
            if (status === 'locked') {
                if (lotteryDetail.status > 1) {
                    Toast?.info?.({ content: '抽奖活动已结束' });
                    return;
                }
                Toast?.info?.({ content: '还未达到累计人数，快去邀请好友注册吧' });
                return;
            }
            
            // 待发货状态，提示用户等待或打开 App
            if (status === 'pendingShipping') {
                // 打开 App 查看详情
                this.openAppLotteryDetailPage();
                return;
            }
            
            // 已发货状态，打开 App 查看物流
            if (status === 'shipped') {
                this.openAppLotteryDetailPage();
                return;
            }
            
            // 已发放状态（抽奖券或虚拟奖品）
            if (status === 'granted') {
                // prizeType=0（抽奖券）-> 显示我的邀请弹框
                if (milestone.prizeType == 0) {
                    await Promise.all([
                        this.fetchLotteryActivitiesInvitations(1, false),
                        this.fetchLotteryActivitiesSurprises(1, false)
                    ]);
                    this.setState({ myInviteUserListPopupStatus: true });
                    return;
                }
                // 其他情况打开 App
                this.openAppLotteryDetailPage();
                return;
            }
            
            // 可领取状态（claimable）-> 打开 App
            if (status === 'claimable') {
                this.openAppLotteryDetailPage();
                return;
            }
        };
        
        if (MILESTONES.length === 0) {
            return null;
        }
        
        return (
            <div className={styles.progressContainer}>
                <div className={styles.progressTitle}>达到指定邀请人数，得<span>额外惊喜</span></div>     
                {/* 进度条区域 */}
                <div className={styles.progressSection}>
                    <div className={styles.progressBarWrapper}>
                        {/* 节点标记 */}
                        <div className={styles.nodesContainer}>
                            {MILESTONES.map((milestone, idx) => {
                                const active = isNodeActive(milestone.target);
                                return (
                                    <div 
                                        key={milestone.id}
                                        className={classNames(styles.node, {
                                            [styles.nodeActive]: active,
                                        })}
                                        style={{ left: `${milestone.progressWidth}%` }}
                                    >
                                        <div className={styles.nodeLabel}>累计{milestone.target}人</div>
                                        <div className={styles.nodeDot} />
                                    </div>
                                );
                            })}
                        </div>
                        <div className={styles.progressBar}>
                            <div className={styles.progressFill} style={{ width: `${progressWidth}%` }} />
                        </div>
                    </div>
                </div>
                
                {/* 里程碑奖励列表 */}
                <div className={styles.milestonesList}>
                    {MILESTONES.map((milestone, index) => {
                        const status = getNodeStatus(milestone);
                        const buttonText = getButtonText(milestone, status);
                        const displayText = getDisplayText(milestone);
                        const showIcon = shouldShowIcon(status);
                        const isItemDisabled = status === 'locked' && lotteryDetail.status > 1;
                        
                        return (
                            <div 
                                key={milestone.id} 
                                className={classNames(styles.milestoneItem, {
                                    [styles.milestoneAchieved]: status === 'granted' || status === 'shipped' || status === 'claimable',
                                    [styles.milestoneClaimable]: status === 'claimable',
                                    [styles.milestoneDisabled]: isItemDisabled,
                                })}
                                onClick={() => handleMilestoneClick(milestone)}
                            >
                                <div className={styles.itemBg}></div>
                                <div className={styles.itemContent}>
                                    <img 
                                        src={milestone.prizeType == 0 ? `${BASE_IMG_URL}/lottery/icon1.png` : milestone.prize?.icon || `${BASE_IMG_URL}/lottery/icon1.png`} 
                                        alt="" 
                                        className={styles.icon}
                                    />
                                    <div className={styles.text}>{displayText}</div>
                                    <div className={styles.milestoneStatus}>
                                        {showIcon && <img src={`${BASE_IMG_URL}/lottery/check_icon.png`} alt="" className={styles.statusIcon} />}
                                        <span className={classNames({
                                            [styles.statusGranted]: status === 'granted',
                                            [styles.statusClaimable]: status === 'claimable',
                                            [styles.statusShipped]: status === 'shipped',
                                            [styles.statusExpired]: status === 'expired',
                                            [styles.statusSoldOut]: status === 'soldOut',
                                        })}>
                                            {buttonText}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };            
    
    // 拉新排行榜
    renderUserAcquisitionRanking = () => {
        const { lotteryDetail, user } = this.props;
        const rankingLength = lotteryDetail.inviteRanking?.length || 0;
        let rankingListNew = rankingLength <= 10 ? lotteryDetail.inviteRanking : (lotteryDetail.status > 1 ? lotteryDetail.inviteRanking : lotteryDetail.inviteRanking?.slice(3));
        const totalShowStock = lotteryDetail.invitePrizes?.reduce((sum, item) => sum + item.showStock, 0);
        // status==1且rankingLength>10时，topThreeBox占用了前3名，列表中库存名额需减去3
        const effectiveStock = (rankingLength > 10 && lotteryDetail.status == 1) ? totalShowStock - 3 : totalShowStock;
        console.log(totalShowStock, '库存数')
        return (
            <div className={styles.rankingOuterBox}>
                {(rankingLength > 10 && lotteryDetail.status == 1) && <div className={styles.topThreeBox}>
                    <div className={classNames(styles.rankTopItem, styles.rankSecond)}>
                        <img src={`${BASE_IMG_URL}/lottery/second.png`} alt="" className={styles.rankNum}/>
                        <Avatar
                            avatarUrl={lotteryDetail.inviteRanking[1].avatar}
                            userCode={lotteryDetail.inviteRanking[1].code}
                            size={118}
                            officialSize={36}
                            showOfficialTag={true}
                            titleMark={lotteryDetail.inviteRanking[1].titleMark}
                        />
                        <div className={styles.nickname}>{lotteryDetail.inviteRanking[1].nickname}</div>
                        <div className={styles.inviteNum}>已邀{lotteryDetail.inviteRanking[1].inviteCount}人</div>
                    </div>
                    <div className={classNames(styles.rankTopItem, styles.rankFirst)}>
                        <img src={`${BASE_IMG_URL}/lottery/first.png`} alt="" className={styles.rankNum}/>
                        <Avatar
                            avatarUrl={lotteryDetail.inviteRanking[0].avatar}
                            userCode={lotteryDetail.inviteRanking[0].code}
                            size={148}
                            officialSize={36}
                            showOfficialTag={true}
                            titleMark={lotteryDetail.inviteRanking[0].titleMark}
                        />
                        <div className={styles.nickname}>{lotteryDetail.inviteRanking[0].nickname}</div>
                        <div className={styles.inviteNum}>已邀{lotteryDetail.inviteRanking[0].inviteCount}人</div>
                    </div>
                    <div className={classNames(styles.rankTopItem, styles.rankThird)}>
                        <img src={`${BASE_IMG_URL}/lottery/third.png`} alt="" className={styles.rankNum}/>
                        <Avatar
                            avatarUrl={lotteryDetail.inviteRanking[2].avatar}
                            userCode={lotteryDetail.inviteRanking[2].code}
                            size={118}
                            officialSize={36}
                            showOfficialTag={true}
                            titleMark={lotteryDetail.inviteRanking[2].titleMark}
                        />
                        <div className={styles.nickname}>{lotteryDetail.inviteRanking[2].nickname}</div>
                        <div className={styles.inviteNum}>已邀{lotteryDetail.inviteRanking[2].inviteCount}人</div>
                    </div>
                </div>}
                {rankingListNew.length > 0 && <div className={styles.rangkingList} style={{paddingBottom: !(lotteryDetail.user && (lotteryDetail.status == 1 || (lotteryDetail.status > 1 && lotteryDetail.user?.inviteWinning?.prizeName))) ? 0 : px2rem(60)}}>
                    {rankingListNew?.map((rank, index) => {
                        // 计算当前排名（与 App 端对齐）
                        const isOverMany = lotteryDetail.status == 1 && rankingLength > 10;
                        const rankNum = isOverMany
                            ? (index === 0 ? 2 : index === 1 ? 1 : index === 2 ? 3 : index + 1)
                            : index + 1;

                        // 根据排名查找对应的奖品
                        const prizeList = lotteryDetail.invitePrizes || [];
                        let targetPrize = null;
                        let currentRankLimit = 0;
                        let startRank = 0;
                        for (const prize of prizeList) {
                            startRank = currentRankLimit + 1;
                            currentRankLimit += prize.showStock;
                            if (rankNum >= startRank && rankNum <= currentRankLimit) {
                                targetPrize = prize;
                                break;
                            }
                        }

                        // 判断是否显示 itemReward
                        let showItemReward = false;
                        if (!isOverMany && lotteryDetail.status > 1 && targetPrize) {
                            if (targetPrize.showStock > 1) {
                                // 库存>1：只在区间起始排名显示
                                showItemReward = rankNum === startRank;
                            } else if (targetPrize.showStock === 1) {
                                // 库存=1：直接显示
                                showItemReward = true;
                            }
                        }

                        return (
                        <div className={styles.rankItem}>
                            {showItemReward && targetPrize && <div className={styles.itemReward}>
                                <img src={targetPrize.icon} alt="" className={styles.rewardIcon}/>
                                <div className={styles.rewardName}>{targetPrize.award + targetPrize.name}</div>
                            </div>}
                            <div className={styles.rankItemContent}>
                                {(index == 0 && lotteryDetail.status >= 1 && (rankingLength <= 10 || lotteryDetail.status > 1)) && <img src={`${BASE_IMG_URL}/lottery/first.png`} alt="" className={styles.rankIndexIcon}/>}
                                {(index == 1 && lotteryDetail.status >= 1 && (rankingLength <= 10 || lotteryDetail.status > 1)) && <img src={`${BASE_IMG_URL}/lottery/second.png`} alt="" className={styles.rankIndexIcon}/>}
                                {(index == 2 && lotteryDetail.status >= 1 && (rankingLength <= 10 || lotteryDetail.status > 1)) && <img src={`${BASE_IMG_URL}/lottery/third.png`} alt="" className={styles.rankIndexIcon}/>}
                                {((rankingLength <= 10 && index > 2) || (rankingLength > 10 && (lotteryDetail.status == 1 || index > 2))) && <div className={classNames(styles.rankIndex, index >= effectiveStock ? styles.rankIndexGray : '')}>{rankingLength > 10 && lotteryDetail.status == 1 ? index + 4 : index + 1}</div>}
                                <Avatar
                                    avatarUrl={rank.avatar}
                                    userCode={rank.code}
                                    size={60}
                                    officialSize={24}
                                    showOfficialTag={true}
                                    titleMark={rank.titleMark}
                                />
                                <div className={classNames(styles.nickname, (index >= effectiveStock || lotteryDetail.status > 1) ? styles.nicknameGray : '')}>{rank.nickname}</div>
                                <div className={styles.inviteNum}>已邀{rank.inviteCount}人</div>
                            </div>
                        </div>
                        );
                    })}
                </div>}
                {lotteryDetail.user && (lotteryDetail.status == 1 || (lotteryDetail.status > 1 && lotteryDetail.user?.inviteWinning?.prizeName)) && <div className={styles.myRankInfoBox} ref={(el) => { this.myRankInfoRef = el; }} style={{ opacity: 1, pointerEvents: 'auto' }}>
                    {lotteryDetail.user?.inviteRanking == 1 && <img src={`${BASE_IMG_URL}/lottery/first.png`} alt="" className={styles.rankIndexIcon}/>}
                    {lotteryDetail.user?.inviteRanking == 2 && <img src={`${BASE_IMG_URL}/lottery/second.png`} alt="" className={styles.rankIndexIcon}/>}
                    {lotteryDetail.user?.inviteRanking == 3 && <img src={`${BASE_IMG_URL}/lottery/third.png`} alt="" className={styles.rankIndexIcon}/>}
                    {(lotteryDetail.user?.inviteRanking > 3 || lotteryDetail.user?.inviteRanking == 0) && <div className={classNames(styles.rankIndex, (lotteryDetail.user?.inviteRanking >= effectiveStock || lotteryDetail.user?.inviteRanking == 0) ? styles.rankIndexGray : '')}>{lotteryDetail.user?.inviteRanking == 0 ? '--' : lotteryDetail.user?.inviteRanking <= 100 ? lotteryDetail.user?.inviteRanking : '100+'}</div>}
                    <Avatar
                        avatarUrl={lotteryDetail.user?.avatar}
                        userCode={lotteryDetail.user?.code}
                        size={60}
                        showOfficialTag={false}
                    />
                    <div className={styles.myRankInfo}>
                        <div className={styles.infoTop}>
                            <div className={styles.nickname}>{lotteryDetail.user?.nickname}</div>
                            <div className={styles.inviteNum}>{lotteryDetail.inviteUsers?.length == 0 ? '暂无排名' :'已邀' + lotteryDetail.user?.inviteCount + '人'}</div>
                        </div>
                        {(lotteryDetail.status > 1 && lotteryDetail.user?.inviteWinning?.prizeName && lotteryDetail.inviteUsers?.length > 0) && <div className={styles.myReward}>恭喜你获得{lotteryDetail.user?.inviteWinning?.prizeName}</div>}
                    </div>
                    {lotteryDetail.status == 1 && <div className={styles.goInviteBtn} onClick={() => this.inviteFriend()}>去邀请</div>}
                    {lotteryDetail.status > 1 && <div onClick={() => {
                        this.openAppLotteryDetailPage();
                    }}>
                        {/* 不是实物 */}
                        {lotteryDetail.user?.inviteWinning?.prizeType != 2 && <div className={classNames(styles.goInviteBtn)}>已发放</div>}
                        {/* 是实物 */}
                        {lotteryDetail.user?.inviteWinning?.prizeType == 2 && <div className={classNames(styles.goInviteBtn, !lotteryDetail.user?.inviteWinning?.order ? styles.goInviteBtn2 : '', lotteryDetail.user?.inviteWinning?.isReceived == 2 && styles.goInviteBtn3)}>
                            {/* isReceived为0是未领取，1是已领取，2是已过期 */}
                            {lotteryDetail.user?.inviteWinning?.isReceived == 2 && <span>已过期</span>}
                            {(lotteryDetail.user?.inviteWinning?.isReceived == 0 || !lotteryDetail.user?.inviteWinning?.order) && <span>填写地址</span>}
                            {lotteryDetail.user?.inviteWinning?.isReceived == 1 && !lotteryDetail.user?.inviteWinning?.order?.isShipped && <span>待发货</span>}
                            {lotteryDetail.user?.inviteWinning?.isReceived == 1 && lotteryDetail.user?.inviteWinning?.order?.isShipped && <span>已发货</span>}
                        </div>}
                    </div>}
                </div>}
            </div>
        )
    }

    // 抽奖结果弹框
    // 显示队列中的下一个奖品
    showNextPrizeFromQueue = () => {
        const { pendingPrizeQueue } = this.state;
        
        if (pendingPrizeQueue.length === 0) {
            return;
        }
        
        // 取出队列中的第一个奖品
        const nextPrize = pendingPrizeQueue[0];
        const remainingQueue = pendingPrizeQueue.slice(1);
        
        // inviteTasks 的 prizeType: 0=抽奖券, 1=奖品
        // userWinning 的 prizeType: 1=V币, 2=实物, 3=优惠券, 4=谢谢参与
        let prizeName, prizeIcon, prizeType;
        
        if (nextPrize.prizeType === 0) {
            // 抽奖券
            prizeName = `抽奖券×${nextPrize.rewardTickets || 1}`;
            prizeIcon = `${BASE_IMG_URL}/lottery/icon1.png`;
            prizeType = 0; // 特殊类型：自动到账的抽奖券
        } else {
            // 实物奖品，使用 prize 里的具体信息
            prizeName = nextPrize.prize?.name || '神秘奖品';
            prizeIcon = nextPrize.prize?.icon || `${BASE_IMG_URL}/lottery/icon1.png`;
            // prize.type: 1=V币, 2=实物, 3=优惠券
            prizeType = nextPrize.prize?.type || 2;
        }
        
        this.setState({
            inviteLotteryPrizeResultData: {
                ...nextPrize,
                name: prizeName,
                icon: prizeIcon,
                type: prizeType,
                inviteCount: nextPrize.inviteCount
            },
            openPrizeType: 1,
            lotteryResultPopupStatus: true,
            pendingPrizeQueue: remainingQueue
        });
    }

    // 关闭奖品弹框并检查是否继续显示下一个
    closeLotteryResultPopup = () => {
        console.log('关闭');
        this.setState({
            lotteryResultPopupStatus: false
        }, () => {
            // 延迟一下再显示下一个，让关闭动画完成
            setTimeout(() => {
                this.showNextPrizeFromQueue();
            }, 300);
        });
    }

    lotteryResultPopup = () => {
        const { lotteryDetail } = this.props;
        const { currentLotteryPrizeResultData, openPrizeType, inviteLotteryPrizeResultData } = this.state;
        // 使用类型断言避免 TypeScript 检查
        const prizeData = openPrizeType == 1 ? inviteLotteryPrizeResultData as any : currentLotteryPrizeResultData as any;
        
        // prizeData.type类型：1-V币 2-实物 3-优惠券 4-谢谢参与
        return (
            <div className={classNames(styles.popupBox, styles.lotteryResultPopupBox)}>
                <div className={styles.popupMask} onClick={() => {
                        this.closeLotteryResultPopup();
                    }}></div>
                <div className={styles.popupContent}>
                    <div className={styles.popupTitleBox}>
                        <img src={`${BASE_IMG_URL}/lottery/icon8.png`} alt="" className={styles.icon}/>
                        {openPrizeType == 1 &&<div className={styles.text}>已累计邀请{prizeData.inviteCount}人<br/>恭喜你获得</div>}
                        {openPrizeType == 2 && <div className={styles.text}>
                            {prizeData.type == 4 ? <>
                                祝你今天<br/>幸运满满
                            </> : <>恭喜你抽中</>}
                        </div>}
                        <img src={`${BASE_IMG_URL}/lottery/icon8.png`} alt="" className={styles.icon}/>
                    </div>
                    <div className={styles.lotteryDetailOuterBox}>
                        <div className={styles.lotteryDetailBox}>
                            <img src={prizeData.icon} alt="" className={styles.icon}/>
                            <div className={styles.prizeName}>{prizeData.name}</div>
                        </div>
                    </div>
                    <div className={styles.lotterySureBtn} onClick={() => {
                        if (openPrizeType == 1) {
                            // 邀请奖品：抽奖券(type=0)直接关闭，其他奖品去领取
                            if (prizeData.type === 0) {
                                this.closeLotteryResultPopup();
                            } else {
                                // 实物/V币/优惠券：跳转到 App 领取
                                // window.location.href = `vivoclub://com.vivo.club/deep?page=page_lottery_detail&id=${lotteryDetail?.id}&action=H5openLotteryApp`;
                                // // 3秒后如果应用没有打开，跳转到应用商城
                                // setTimeout(() => {
                                //     window.open(`https://m.malink.cn/s/ABbE73`)
                                // }, 3000);
                                this.openAppLotteryDetailPage();
                            }
                        } else {
                            // 抽奖结果：谢谢参与(type=4)直接关闭，其他奖品去领取
                            if (prizeData.type == 4) {
                                this.closeLotteryResultPopup();
                            } else {
                                // window.location.href = `vivoclub://com.vivo.club/deep?page=page_lottery_detail&id=${lotteryDetail?.id}&action=H5openLotteryApp`;
                                // setTimeout(() => {
                                //     this.closeLotteryResultPopup();
                                //     window.open(`https://m.malink.cn/s/ABbE73`)
                                // }, 3000);
                                this.openAppLotteryDetailPage();
                            }
                        }
                    }}>
                        {openPrizeType == 1 
                            ? (prizeData.type === 0 ? '返回继续抽奖' : '去领取')
                            : (prizeData.type == 4 ? '返回继续抽奖' : '去领取')
                        }
                    </div>
                </div>
            </div>
        )
    }

    render() {
        let { site, lotteryDetail, navList, navCurrentIndex, navClick, themeColor } = this.props;
        let { showFixedNav, rulePopupStatus, sharePopupStatus, lotteryResultPopupStatus, myLotteryCouponPopupStatus, myLotteryRecordPopupStatus, myInviteUserTabList, myInviteUserListPopupStatus, currentInviteTabIype, lotteryActivitiesTickets, lotteryActivitiesRecords, inviteCode, lotteryActivitiesSurprises, lotteryActivitiesBarrage, pendingPrizeQueue, ruleText, ruleType, inviteForUserPopupStatus, ticketsHasMore, ticketsLoading, recordsHasMore, recordsLoading, lotteryActivitiesInvitations, invitationsHasMore, invitationsLoading, surprisesHasMore, surprisesLoading, showMyRankInfo, prizeQueueInitialized, weiXinTipMask } = this.state;
        // 从 site store 获取下载入口状态，确保关闭时能自动更新
        // const downloadAppStatus = site?.appDownloadShowStatus ?? false;
        console.log(lotteryActivitiesRecords, '中奖记录')
        const filterSharePrizesArr = lotteryDetail.turntablePrizes?.filter(item => item.type !== 4).slice(0, 2);  // 用来取分享出去的奖品名称
        const isProdEnv = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
        let copyText = ''
        // 根据环境确定域名
        const domain = isProdEnv ? 'https://club.vivo.com.cn' : 'https://club.vivo.com.cn';
        // 构建基础 URL
        let url = `${domain}/lottery/${lotteryDetail?.code || ''}?usercode=${lotteryDetail?.user?.code}`;
        // 如果邀请码不为空，拼接 inviteCode 参数
        if (inviteCode != '') {
            url += `&inviteCode=${inviteCode}`;
        }
        // 生成分享文案
        copyText = `快来参与vivo社区「${lotteryDetail.name}」，有机会拿下${filterSharePrizesArr?.[0]?.name}、${filterSharePrizesArr?.[1]?.name}，看看谁才是欧皇！\r\n${url}，\r\n复制本消息打开vivo社区App即可查看详情~`;
        
        console.log(lotteryResultPopupStatus, '奖品结果弹框')
        
        const wrapperPaddingTop = this.getWrapperPaddingTop();
        const surprisesCount = lotteryDetail.inviteTasks?.filter(item => item.isFinished).length;

        return (<>
                {!lotteryDetail.id && <div className={styles.pageLoading}>
                    <img src={`${BASE_IMG_URL}/common/loading.png`} alt="" className={styles.loadingIcon}/>
                    <div className={styles.loadingText}>好运加载中...</div>
                </div>}
                {/* paddingBottom: !lotteryDetail.user ? 0 : px2rem(120) */}
                {lotteryDetail.id && <div className={styles.wrapper} style={{background: lotteryDetail.backgroundColor, paddingBottom: lotteryDetail.status == 0 ? px2rem(240) : 0, paddingTop: wrapperPaddingTop}}>
                    <div className={styles.topContent}>
                        <img src={`${BASE_IMG_URL}/lottery/home.png`} alt="" className={styles.goHome} onClick={() => {
                            this.props.history.push(`/`);
                        }}/>
                        <img src={updateImageListSrc(lotteryDetail.coverUrl, 20)} alt="" className={styles.coverImg} />
                        <div className={styles.enterInfoBox}>
                            <div className={styles.enterItem} onClick={() => {
                                this.setState({ rulePopupStatus: true, ruleText: lotteryDetail.rules, ruleType: 0 })
                            }}>
                                <img src={`${BASE_IMG_URL}/lottery/icon3.png`} alt="" className={styles.enterIcon}/>
                                <span className={styles.enterText}>活动规则</span>
                            </div>
                            {/* <div className={styles.enterItem} onClick={() => {
                                this.setState({ sharePopupStatus: true })
                            }}>
                                <img src={`${BASE_IMG_URL}/product/icon4.png`} alt="" className={styles.enterIcon}/>
                                <span className={styles.enterText}>分享</span>
                            </div> */}
                        </div>
                        {/* 中奖弹幕 */}
                        {lotteryActivitiesBarrage?.length > 0 && <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            direction={'vertical'}
                            slidesPerView={1}
                            autoplay={{
                                delay: 2000,        // 2秒切换一次
                                disableOnInteraction: false,  // 用户交互后不停止自动播放
                                pauseOnMouseEnter: true,      // 鼠标悬停时暂停
                            }}
                            loop={lotteryActivitiesBarrage.length > 1}
                            onSlideChange={() =>{}}
                            style={{ height: px2rem(56) }}
                            className={classNames(styles.prizeNoticeSwiper)}
                        >
                        {lotteryActivitiesBarrage.map((barrage, index) => (
                            <SwiperSlide key={barrage.id || index}>
                                <div className={styles.prizeNoticeToast}>
                                    <Avatar
                                        avatarUrl={barrage?.avatar}
                                        userCode=''
                                        size={32}
                                    />
                                    <div className={styles.text}>恭喜{barrage?.nickname}抽中{barrage?.name}</div>    
                                </div>
                            </SwiperSlide>
                        ))}
                        </Swiper>}
                        
                    </div>
                    <div className={styles.content}>
                        {/* 九宫格抽奖 */}
                        {lotteryDetail.turntablePrizes?.length > 0 && <NineGridLottery
                            lotteryData={lotteryDetail}
                            prizes={lotteryDetail.turntablePrizes}
                            onDraw={this.handleDraw}
                            onLotteryEnd={(result) => {
                                console.log('中奖结果:', result);
                            }}
                            openLotteryActivitiesDrawsList={async () => {
                                if (!this.props.user?.userInfo?.code) {
                                    const { user } = this.props as any;
                                    if (user && typeof user.checkLogin === 'function') {
                                        const isLogin = user.checkLogin();
                                        if (!isLogin) {
                                            return;
                                        }
                                    }
                                    Toast.info({ content: '请先登录!' });
                                    return;
                                }
                                // 先加载数据，再显示弹框
                                await this.fetchLotteryActivitiesRecords(1, false);
                                this.setState({
                                    myLotteryRecordPopupStatus: true
                                })
                            }}
                            openLotteryActivitiesTicketsList={async () => {
                                if (!this.props.user?.userInfo?.code) {
                                    const { user } = this.props as any;
                                    if (user && typeof user.checkLogin === 'function') {
                                        const isLogin = user.checkLogin();
                                        if (!isLogin) {
                                            return;
                                        }
                                    }
                                    Toast.info({ content: '请先登录!' });
                                    return;
                                }
                                // 先加载数据，再显示弹框
                                await this.fetchLotteryActivitiesTickets(1, false);
                                this.setState({
                                    myLotteryCouponPopupStatus: true
                                })
                            }}
                            themeColor={themeColor}
                        />}

                        {/* 任务 */}
                        {lotteryDetail.tasks?.length > 0 && <div className={styles.commonBox}>
                            <div className={styles.commonTitleBox}>
                                <div className={styles.commonTitle}>做任务，得<span>抽奖券</span></div>
                            </div>
                            {this.taskList()}
                        </div>}
                        {this.isWeixin() && <div style={{width: '100%', height: px2rem(24)}}></div>}
                        {/* 是否开启邀请拉新 */}
                        {lotteryDetail.enableInvite && <>

                            {/* 邀请新人 */}
                            {!this.isWeixin() && <div className={styles.commonBox}>
                                <div className={styles.commonTitleBox}>
                                    <div className={styles.commonTitle}>邀新人注册，开<span>抽奖券</span></div>
                                </div>

                                {/* 邀请好友进度列表 */}
                                {this.renderInviteUserList()}

                                <div className={classNames(styles.inviteBtn, lotteryDetail.status != 1 ? styles.inviteBtnGray : '')} onClick={() => this.inviteFriend()}>
                                    {lotteryDetail.status <= 1 && <>
                                        邀请好友<span>开更多抽奖券</span>
                                    </>}
                                    {lotteryDetail.status > 1 && <>
                                        活动已结束
                                    </>}
                                </div>

                                {/* 邀请进度 */}
                                {lotteryDetail?.inviteTasks?.length > 0 && <>
                                    {this.renderProgressBar()}
                                    
                                </>}
                                <div className={styles.inviteProgressInfo} onClick={async() => {
                                    let { user, common, lotteryDetail } = this.props;
                                    if (!user?.userInfo?.code) {
                                        // const { user } = this.props as any;
                                        if (user && typeof user.checkLogin === 'function') {
                                            const isLogin = user.checkLogin();
                                            if (!isLogin) {
                                                return;
                                            }
                                        }
                                        Toast.info({ content: '请先登录!' });
                                        return;
                                    }
                                    // 先加载数据，再显示弹框
                                    await Promise.all([
                                        this.fetchLotteryActivitiesInvitations(1, false),
                                        this.fetchLotteryActivitiesSurprises(1, false)
                                    ]);
                                    this.setState({
                                        myInviteUserListPopupStatus: true
                                    })
                                }}>
                                    {lotteryDetail.user?.totalTicketsByInvite > 0 && <div className={styles.inviteCount}>可抽奖{lotteryDetail.user?.totalTicketsByInvite}次</div>}
                                    <div className={styles.inviteProgressContent}>
                                        {lotteryDetail.inviteUsers?.length > 0 && <>你已邀请 <span>{lotteryDetail.user?.inviteCount}</span> 人，共获得 <span>{lotteryDetail.user?.totalTicketsByInvite}</span> 抽奖券</>}
                                        {lotteryDetail.inviteUsers?.length == 0 && <>我的邀请</>}
                                    </div>
                                </div>
                            </div>}

                            {/* 拉新 */}
                            {(!this.isWeixin() && lotteryDetail.invitePrizes?.length > 0) && <div 
                                ref={(el) => { this.rankSectionRef = el; }}
                                className={styles.commonBox}
                            >
                                <div className={styles.commonTitleBox}>
                                    <div className={styles.commonTitle}>拉新冲榜，赢<span>大奖</span></div>
                                    <img src={`${BASE_IMG_URL}/lottery/icon2.png`} alt="" className={styles.ruleIcon} onClick={() => {
                                        this.setState({ rulePopupStatus: true, ruleText: lotteryDetail.inviteRules, ruleType: 1 })
                                    }}/>
                                </div>

                                {/* 当有多个奖品时 */}
                                {lotteryDetail.invitePrizes?.length > 0 && 
                                    
                                    <div className={classNames(styles.prizeMoreBox, lotteryDetail.invitePrizes?.length > 3 && styles.prizeMoreList, lotteryDetail.status > 1 ? styles.prizeMoreGrayBox : '')}>
                                        <div className={styles.prizeListOuterBox}>
                                            <div className={styles.prizeListBox} style={{justifyContent: lotteryDetail.invitePrizes?.length <= 3 ? 'center' : 'space-between'}}>
                                                {lotteryDetail.invitePrizes?.map((prize) => (
                                                    <div className={styles.prizeItem}>
                                                        <img src={prize.icon} alt="" className={styles.prizeIcon} />
                                                        <div className={styles.prizeName}>{prize.name}</div>
                                                        <div className={classNames(styles.prizeLimit, lotteryDetail.status > 1 ? styles.prizeLimitGray : '')}>{prize.award}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {/* 进行中时显示倒计时 */}
                                        {lotteryDetail.status == 1 && <div className={styles.time}>距结束：<CountDown number={new Date(lotteryDetail.endAt).getTime()} endText='&nbsp;' itemStylesData={{background: 'transparent',color: '#ED4D47',padding: '0', height: px2rem(32), lineHeight: px2rem(32)}} boxStylesData={{justifyContent:'center', color:'#939598'}}/></div>}
                                        {lotteryDetail.status > 1 && <div className={styles.endBottom}>活动已结束</div>}
                                    </div>
                                    
                                }

                                {/* 拉新排行榜 */}
                                {this.renderUserAcquisitionRanking()}
                                {lotteryDetail.inviteRanking?.length == 0 && <div className={styles.lookForward}>
                                    <img src={`${BASE_IMG_URL}/lottery/icon10.png`} alt="" className={styles.icon} />
                                    <div className={styles.text}>{lotteryDetail.status > 1 ? '活动已结束' : '敬请期待'}</div>
                                </div>}
                            </div>}
                            {(!this.isWeixin() && lotteryDetail.status > 0 && lotteryDetail.inviteRanking?.length >= 50) &&  <div className={styles.rankingBottomTip}>活动仅展示前50名</div>}
                        </>}
                        {lotteryDetail.status == 0 && <div className={styles.noStartFooterBox}>
                            <CountDown number={new Date(lotteryDetail.startAt).getTime()} endText='&nbsp;后开始' itemStylesData={{}} boxStylesData={{justifyContent:'center', color:'#939598'}}/>
                            <div className={styles.noStartBtn}>即将开始</div>
                        </div>}

                        {/* 被某个用户邀请后初次进入的弹框 */}
                        <CommonPopupNew
                            visible={inviteForUserPopupStatus}
                            title=""
                            isShowCancel={false}
                            isShowConfirm={false}
                            onCancelChange={() => this.onHidePopup()}
                            onConfirmButtonChange={() => {}}
                            >
                            {/* children 插槽内容 */}
                            <div className={styles.inviteForUserPopupContentBox}>
                                <Avatar
                                    avatarUrl={lotteryDetail.user?.inviter?.avatar}
                                    userCode={lotteryDetail.user?.inviter?.code}
                                    size={88}
                                    officialSize={24}
                                    showOfficialTag={true}
                                    titleMark={lotteryDetail.user?.inviter?.titleMark}
                                />
                                <div className={styles.username}>{lotteryDetail.user?.inviter?.nickname}<br/>邀请你加入vivo社区</div>
                                {lotteryDetail.defaultTickets != 0 && <div className={styles.tip}>恭喜你获得<span>抽奖券x{lotteryDetail.defaultTickets}</span></div>}
                                <div className={styles.couponConfirmBtn} onClick={() => {
                                    this.setState({
                                        inviteForUserPopupStatus: false
                                    })
                                }}>去抽奖</div>
                            </div>
                        </CommonPopupNew>

                        {/* 我的抽奖券弹框 */}
                        <CommonPopupNew
                            visible={myLotteryCouponPopupStatus}
                            title="我的抽奖券"
                            isShowCancel={false}
                            isShowConfirm={false}
                            onCancelChange={() => this.onHidePopup()}
                            onConfirmButtonChange={() => {}}
                            >
                            {/* children 插槽内容 */}
                            <div className={styles.myPopupContentBox}>
                                <div className={styles.couponNum}>{lotteryDetail.user?.remainingTickets}</div>
                                <div 
                                    className={classNames(styles.couponListBox, styles.scrollable)}
                                    onScroll={this.handleTicketsScroll}
                                >
                                    {lotteryActivitiesTickets?.length > 0 && <div className={styles.couponList}>
                                        {lotteryActivitiesTickets?.map((coupon, index) => (
                                            <div className={styles.couponItem} key={coupon.id || index}>
                                                <div className={styles.itemLeft}>
                                                    <div className={styles.times}>{coupon.remarks}</div>
                                                    <div className={styles.time}>{formatDateTime(coupon.createdAt)}</div>
                                                </div>
                                                <div className={styles.itemNum} style={{color:coupon.type == 1 ? '#ED4D47': 'inherit' }}>{coupon.type == 1 ? coupon.tickets : '+' + coupon.tickets}</div>
                                            </div>
                                        ))}
                                    </div>}
                                    {/* 当抽奖券使用记录为空时 */}
                                    {lotteryActivitiesTickets?.length == 0 && <>
                                        <img src={`${BASE_IMG_URL}/common/null.png`} alt="" className={styles.nullIcon} />
                                        <div className={styles.nullText}>快去做任务赚取抽奖券吧</div>
                                    </>}
                                    {/* 加载更多提示 */}
                                    {lotteryActivitiesTickets?.length > 0 && ticketsLoading && (
                                        <div className={styles.loadingMore}>加载中...</div>
                                    )}
                                    {/* {lotteryActivitiesTickets?.length > 0 && !ticketsLoading && !ticketsHasMore && (
                                        <div className={styles.noMore}>没有更多了</div>
                                    )} */}
                                </div>
                                <div className={styles.couponConfirmBtn} onClick={() => this.goMakeCoupon()}>{lotteryDetail.user?.remainingTickets == 0 ? '去赚抽奖券' : '去抽奖'}</div>
                            </div>
                        </CommonPopupNew>

                        {/* 我的中奖记录弹框 */}
                        <CommonPopupNew
                            visible={myLotteryRecordPopupStatus}
                            title="中奖记录"
                            isShowCancel={false}
                            isShowConfirm={false}
                            onCancelChange={() => this.onHidePopup()}
                            onConfirmButtonChange={() => {}}
                            >
                            {/* children 插槽内容 */}
                            <div className={styles.myPopupContentBox}>
                                <div 
                                    className={classNames(styles.couponListBox, styles.scrollable)}
                                    onScroll={this.handleRecordsScroll}
                                    style={{ maxHeight: px2rem(750) }}
                                >
                                    {lotteryActivitiesRecords?.length > 0 && <div className={classNames(styles.couponList, styles.recordList)}>
                                        {lotteryActivitiesRecords?.map((record, index) => (
                                            <div className={styles.recordItem} key={record.id || index}>
                                                <img src={record.prizeIcon} alt="" className={styles.recordIcon} />
                                                <div className={styles.itemLeft}>
                                                    <div className={styles.name}>{record.prizeName}</div>
                                                    <div className={styles.time}>{formatDateTime(record.createdAt)}</div>
                                                </div>
                                                {/* 不是实物 */}
                                                {record.prizeType != 2 && <div className={classNames(styles.recordBtn)} onClick={() => this.prizeClick(record)}>已发放</div>}
                                                {/* 是实物 */}
                                                {record.prizeType == 2 && <div className={classNames(styles.recordBtn, (record.isReceived == 0 || !record.order) ? styles.recordBtn2 : '', record.isReceived == 2 && styles.recordBtn3)} onClick={() => this.prizeClick(record)}>
                                                    {/* isReceived为0是未领取，1是已领取，2是已过期 */}
                                                    {record.isReceived == 2 && <span>已过期</span>}
                                                    {(record.isReceived == 0 || !record.order) && <span>填写地址</span>}
                                                    {record.isReceived == 1 && !record.order?.isShipped && <span>待发货</span>}
                                                    {record.isReceived == 1 && record.order?.isShipped && <span>已发货</span>}
                                                </div>}
                                            </div>
                                        ))}
                                    </div>}
                                    {/* 当记录为空时 */}
                                    {lotteryActivitiesRecords?.length == 0 && <>
                                        <img src={`${BASE_IMG_URL}/common/null.png`} alt="" className={styles.nullIcon} />
                                        <div className={styles.nullText}>你还没有中奖</div>
                                    </>}
                                    {/* 加载更多提示 */}
                                    {lotteryActivitiesRecords?.length > 0 && recordsLoading && (
                                        <div className={styles.loadingMore}>加载中...</div>
                                    )}
                                    {/* {lotteryActivitiesRecords?.length > 0 && !recordsLoading && !recordsHasMore && (
                                        <div className={styles.noMore}>没有更多了</div>
                                    )} */}
                                </div>
                                <div className={styles.couponConfirmBtn} onClick={() => {
                                    this.setState({
                                        myLotteryRecordPopupStatus: false
                                    })
                                }}>{lotteryActivitiesRecords?.length == 0 ? '去抽奖' : '我知道了'}</div>
                            </div>
                        </CommonPopupNew>

                        {/* 我的邀请好友弹框 */}
                        <CommonPopupNew
                            visible={myInviteUserListPopupStatus}
                            title=""
                            isShowTitle={false}
                            isShowCancel={false}
                            isShowConfirm={false}
                            onCancelChange={() => this.onHidePopup()}
                            onConfirmButtonChange={() => {}}
                            >
                            {/* children 插槽内容 */}
                            <div className={styles.myPopupContentBox}>
                                <div className={styles.inviteTabListBox}>
                                    {myInviteUserTabList.map((tab) => (
                                        <div className={classNames(styles.tabItem, currentInviteTabIype == tab.type ? styles.tabActive : '')} onClick={() => this.inviteTabClick(tab)}>{tab.name + '(' + (tab.type == 0 ? lotteryDetail.user?.inviteCount: surprisesCount) +')'}</div>
                                    ))}
                                    
                                </div>
                                <div className={styles.inviteListOuterBox}>
                                    <div 
                                        className={styles.inviteListBox}
                                        onScroll={(e) => {
                                            const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                                            // 当滚动到底部附近时触发加载更多
                                            if (scrollHeight - scrollTop - clientHeight < 50) {
                                                if (currentInviteTabIype == 0) {
                                                    this.loadMoreInvitations();
                                                } else {
                                                    this.loadMoreSurprises();
                                                }
                                            }
                                        }}
                                    >
                                        {/* 我的邀请好友列表 */}
                                        {(currentInviteTabIype == 0 && lotteryActivitiesInvitations?.length > 0) && <div className={classNames(styles.inviteList)}>
                                            {lotteryActivitiesInvitations?.map((invite, index) => (
                                                <div className={styles.inviteItem} key={invite.id}>
                                                    {/* <img src={`${BASE_IMG_URL}/common/null.png`} alt="" className={styles.recordIcon} /> */}
                                                    <Avatar
                                                        avatarUrl={invite.invitee?.avatar}
                                                        userCode={invite.invitee?.code}
                                                        size={60}
                                                    />
                                                    <div className={styles.nickname}>{invite.invitee?.nickname}</div>
                                                    <div className={styles.inviteInfo}>
                                                        <div className={styles.num}>+{invite.rewardTickets}</div>
                                                        <div className={styles.time}>{formatDateTime(invite.create_at)}</div>   
                                                    </div>
                                                    
                                                </div>
                                            ))}
                                            {/* 邀请记录加载更多提示 */}
                                            {lotteryActivitiesInvitations?.length > 0 && invitationsLoading && (
                                                <div className={styles.loadingMore}>加载中...</div>
                                            )}
                                            {/* {lotteryActivitiesInvitations?.length > 0 && !invitationsLoading && !invitationsHasMore && (
                                                <div className={styles.noMore}>没有更多了</div>
                                            )} */}
                                        </div>}
                                        {/* 当邀请记录为空时 */}
                                        {(currentInviteTabIype == 0 && lotteryActivitiesInvitations?.length == 0) && <>
                                            <img src={`${BASE_IMG_URL}/common/null.png`} alt="" className={styles.nullIcon} />
                                            <div className={styles.nullText}>快去邀请好友注册吧</div>
                                        </>}

                                        {/* 额外惊喜奖品列表 */}
                                        {(currentInviteTabIype == 1 && lotteryActivitiesSurprises?.length > 0) && <div className={classNames(styles.surpriseList)}>
                                            {lotteryActivitiesSurprises?.map((surprise, index) => (
                                                <div className={styles.prizeItem} key={surprise.id}>
                                                    {surprise.prizeType != 0 && <img src={surprise.userWinning?.prizeIcon} alt="" className={styles.prizeIcon} />}
                                                    {surprise.prizeType == 0 && <img src={`${BASE_IMG_URL}/lottery/icon1.png`} alt="" className={styles.prizeIcon} />}
                                                    <div className={styles.nameBox}>
                                                        <div className={styles.prizeName}>{ surprise.prizeType == 0 ? '抽奖券x' + surprise.rewardTickets : surprise.userWinning?.prizeName}</div>
                                                        <div className={styles.tip}>累计邀请{surprise.inviteCount}人额外惊喜</div>
                                                    </div>
                                                    
                                                    <div className={styles.prizeInfo}>
                                                        <div className={classNames(styles.prizeBtn, (surprise.prizeType == 1 && !surprise.userWinning?.isReceived) ?  styles.prizeBtn1 : '')} onClick={() => this.prizeClick(surprise)}>
                                                            {/* 抽奖券 */}
                                                            {surprise.prizeType == 0 && <>已发放</>}
                                                            {/* 奖品-实物 */}
                                                            {(surprise.prizeType == 1 && surprise.userWinning?.prizeType == 2 && !surprise.userWinning?.isReceived) && <>去领取</>}
                                                            {(surprise.prizeType == 1 && surprise.userWinning?.prizeType != 2 && !surprise.userWinning?.isReceived) && <>去查看</>}
                                                        </div>
                                                        <div className={styles.time}>{formatDateTime(surprise.createdAt)}</div>   
                                                    </div>
                                                    
                                                </div>
                                            ))}
                                            {/* 额外惊喜加载更多提示 */}
                                            {lotteryActivitiesSurprises?.length > 0 && surprisesLoading && (
                                                <div className={styles.loadingMore}>加载中...</div>
                                            )}
                                            {/* {lotteryActivitiesSurprises?.length > 0 && !surprisesLoading && !surprisesHasMore && (
                                                <div className={styles.noMore}>没有更多了</div>
                                            )} */}
                                        </div>}
                                        {/* 当额外惊喜为空时 */}
                                        {(currentInviteTabIype == 1 && lotteryActivitiesSurprises?.length == 0) && <>
                                            <img src={`${BASE_IMG_URL}/common/null.png`} alt="" className={styles.nullIcon} />
                                            <div className={styles.nullText}>这里是空的，快去邀请好友吧</div>
                                        </>}
                                    </div>
                                </div>
                                <div className={styles.couponConfirmBtn} onClick={() => {
                                    this.setState({
                                        myInviteUserListPopupStatus: false
                                    })
                                }}>我知道了</div>
                            </div>
                        </CommonPopupNew>
                            

                        {/* 奖品结果弹框 */}
                        {lotteryResultPopupStatus && this.lotteryResultPopup()}
                        
                        {/* 规则弹框 */}
                        <CommonRulePopup
                            visible={rulePopupStatus}
                            title={ruleType == 0 ? "活动规则" : "冲榜规则"}
                            isShowConfirm={false}
                            richtextContent={ruleText}
                            useRichtext={true}
                            popupStyle={{backgroundImage: "none"}}
                            onConfirmButtonChange={() => this.onHidePopup()}
                        >
                            <div className={styles.ruleConfirmBtn} onClick={() => {
                                this.setState({
                                    rulePopupStatus: false
                                })
                            }}>我知道了</div>
                        </CommonRulePopup>

                        {/* 分享弹框 */}
                        <CommonSharePopup
                            visible={sharePopupStatus}
                            title="分享"
                            copyText={copyText}
                            copyToastText='链接复制成功，快去分享好友吧～'
                            copyLink={() => this.onHidePopup()}
                            onCancelChange={() => this.onHidePopup()}
                        />
                        {/* 微信内提示弹窗 */}
                        {weiXinTipMask && this.isWeixinXml()}
                    </div>
                </div>}
            </>
        )
    }
}

export default withRouter(LotteryH5Page);
